import common from './common'
import featuresPay from './feature'

const zh_TW = {
    featuresPay,
    common,
    SerialNumberDrawer: {
        productVariants: "產品/變體",
        serialNumber: "序號",
        noProductsFound: "未找到產品",
        searchByProductSku: "按產品/SKU搜尋",
        searchSerialNumbers: "搜尋序號",
        transactionDetails: "交易詳情",
        notAvailable: "不適用",
        mainWarehouse: "主倉庫"
    },
    new_build_banner: {
        title: '新版本:',
        is_available: '現已發佈',
        fallback_title: '應用程式有新版本可用',
        desc: '重新整理以獲取最新功能和改進。',
        refreshing: '正在重新整理…',
        refresh_now: '立即重新整理',
        later: '稍後',
        you_are_on: "您目前使用的是"
    },
    short: {
        finance: '財務',
        stock: '庫存'
    },
    onboarding: {
        welcome: '歡迎！',
        step: {
            product: {
                totalBreakdown: '總明細',
                overallFulfilment: '整體履行情況',
                totalShippedQty: '總發貨數量',
                totalReceivedQty: '總接收數量',
                totalOrderedQty: '總訂購數量',
                totalShippedOrdered: '總發貨 / 訂購',
                totalReceivedOrdered: '總接收 / 訂購',
                viewQty: '查看數量',
                fetchingQty: '正在獲取數量詳情...',
                noStockInfo: '未找到庫存資訊',
                title: '已完成 65%',
                description: '只剩 2 個步驟，就能開始您的成功之旅！',
                Warehouse: "倉庫",
            },
            stock: {
                title: '已完成 95% 快完成了！！',
                description: '只剩最後一步，就能開始您的成功之旅！現在就完成吧。'
            }
        },
        business: {
            title: '商家建立成功！',
            description: '太棒了！您的商家已完成註冊'
        },
        product: {
            title: '新增您的第一個商品',
            description: '新增商品開始記錄庫存',
            Warehouse: "倉庫",
        },
        stock: {
            title: '試著新增庫存',
            description: '開始記錄進貨與出貨庫存'
        },
        action: {
            add_business: {
                title: '建立商家',
                description: '想建立新的商家？點這裡'
            },
            join_business: {
                title: '加入商家',
                description: '有邀請碼？點這裡加入'
            }
        }
    },
    business: {
        title: '選擇商家、新建或加入',
        add_business: {
            title: '建立新商家',
            name: '商家名稱',
            name_placeholder: '輸入名稱',
            category: '商家類別',
            category_placeholder: '選擇類別',
            button: '建立商家'
        },
        edit_business: {
            title: '編輯商家'
        },
        join_business: {
            title: '加入商家',
            input_code: '請在下方輸入邀請碼：',
            field_placeholder: '邀請碼',
            confirm_title: '加入',
            confirm_text: '您將成為 '
        },
        no_business: '尚無可用商家',
        create_or_join: '建立或加入商家',
        message: {
            saved: '商家儲存成功！'
        },
        settings: {
            isNegativeTransactionDisabled: '負庫存交易',
            isNegativeTransactionDisabledHint: '開啟此功能後，您可以防止導致庫存變為負數的交易。',
            negativeStockError: '負庫存交易已禁用'
        }
    },
    profile: {
        edit_profile: {
            title: '編輯個人資料',
            name: '完整姓名',
            name_placeholder: '輸入完整姓名',
            email: '電子郵件',
            phone_number: '手機號碼'
        },
        message: {
            required_name: '姓名為必填'
        }
    },
    product: {
        weightedAverageCost: '加權平均成本',
        weightedAverageValueLabel: '加權平均值',
        Product: '商品',
        hideZeroStock: '隱藏零庫存',
        allVariants: '所有規格',
        choose_product: '選擇商品',
        choose_product_empty: '請選擇商品並輸入數量',
        choose_product_empty_manufacturing: '請選擇商品並輸入製造數量',
        search: {
            placeholder: '依名稱搜尋',
            tooltip: '開啟掃描器',
            Warehouse: "倉庫",
        },
        column: {
            image: '照片',
            name: '名稱',
            price: '價格',
            buying_price: '成本價',
            selling_price: '售價',
            sku: 'SKU',
            stock: '庫存',
            quantity: '數量',
            latest_stock: '剩餘',
            product_deleted: '商品已刪除',
            info_not_found: '資訊不可用',
            expired_date: '到期日期',
            invoice: '發票'
        },
        no_product: '尚無商品',
        no_product_subtitle: '添加您的第一個產品以開始跟蹤庫存、價格和銷售。',
        create_first_product: '創建您的第一個產品',
        add_product: {
            sku: '商品編碼',
            sku_placeholder: '商品編碼，例如：12345',
            name: '商品名稱',
            name_placeholder: '輸入商品名稱',
            initial_stock: '初始庫存',
            initial_stock_placeholder: '輸入初始庫存',
            buying_price: '成本價',
            buying_price_placeholder: '輸入成本價',
            selling_price: '售價',
            selling_price_placeholder: '輸入售價',
            category: '類別',
            category_placeholder: '選擇類別',
            add_selling_price: '新增批發價',
            expired_date: '到期日期',
            expired_date_placeholder: '選擇日期',
            description: '描述',
            description_placeholder: '輸入描述',
            custom_label: '屬性',
            custom_label_placeholder: '輸入鍵值',
            add_custom_label: '新增更多屬性',
            Warehouse: "倉庫",
        },
        customerLabel: {},
        choose_selling_price: '選擇售價',
        selling_price: '售價',
        total_product: '商品總數',
        total_quantity: '總庫存量',
        total_buying_price: '總成本價',
        total_selling_price: '總售價',
        message: {
            required_name: '商品名稱為必填',
            required_sku: 'SKU 為必填',
            required_category: '類別為必填',
            required_quantity: '初始庫存為必填',
            invalid_input_qty: '無效的庫存數量',
            required_buying_price: '成本價為必填',
            required_selling_price: '售價為必填',
            required_selling_price_name: '售價名稱為必填',
            required_selling_price_price: '售價金額為必填'
        },
        viewMore: '查看更多',
        WarehouseDetails: '倉庫詳情',
        WarehouseName: '倉庫名稱',
        AddWarehouse: '新增倉庫',
        WarehouseQty: '倉庫數量',
        Warehouse: '倉庫',
        Warehouses: '倉庫',
        Variants: '變體',
        VariantName: '變體名稱',
        productVariant: '商品變體',
        AddVariant: '新增變體',
        TranferItem: '轉移項目',
        AddUnit: '新增單位',
        InitialStkWarehouse: '新增變體需先設定初始庫存',
        InitialStockinwarehouse: '倉庫初始庫存',
        TotalQuantity: '總數量：',
        AddNote: '新增備註（成本價）',
        AddNotetitle: '新增備註',
        VariantSuccessMessage: '商品變體更新成功',
        Next: '下一步',
        Submit: '送出',
        INACTIVE: '未啟用',
        errorone: '哎呀！要求的數量對於',
        errortwo: '與分配的倉庫數量不符。請調整數量或補貨。',
        SelectWarehouse: '選擇倉庫',
        SelectVariant: '選擇變體',
        Discount: '折扣',
        DiscountDetails: '折扣詳情',
        FinalPrice: '最終價格',
        DiscountType: '折扣類型',
        DiscountPer: '折扣 %',
        DiscountValue: '折扣金額',
        Discountonprice: '直接折扣價格',
        Discountondiscount: '疊加折扣',
        AdditionalDiscount: '額外折扣',
        SellingPrice: '售價：',
        Save: '儲存',
        OnOriginalPrice: '基於原價',
        OnDiscountedPrice: '基於折扣後價格',
        columnSelector: {
            title: '顯示列',
            columnsButton: '列',
            costPrice: '成本價',
            sellingPrice: '銷售價',
            sku: 'SKU',
            warehouse: '倉庫',
            categories: '分類',
            safetyStock: '安全庫存',
            attributes: '屬性',
            notes: '備註',
            description: '描述',
            more: '更多',
            attribute: '屬性',
            attributesTitle: '屬性',
            categoriesTitle: '分類',
            skuAliases: 'SKU 別名'
        }
    },
    note: {
        title: '備註',
        add: '新增備註',
        no_note: '尚無備註'
    },
    settings: {
        category: '類別',
        language: '語言',
        switch_business: '切換商家',
        currencySelect: '貨幣',
        languageChangeSuccess: '貨幣更新成功',
        languageChangeErrorMessage: '更新貨幣時發生錯誤',
        currencyAdded: "貨幣新增成功",
        currencyDelete: "貨幣刪除成功",
        Selectyourpreferredlanguage: "選擇您偏好的語言"
    },
    selectProductStock: '選擇商品',
    category: {
        category_list: {
            title: '商品類別'
        },
        add_category: {
            button: '新增類別',
            title: '新增類別'
        },
        edit_category: {
            title: '編輯類別'
        },
        name: '類別名稱',
        name_placeholder: '輸入類別名稱',
        no_category: '尚無類別'
    },
    staff: {
        add: '新增員工',
        edit: '編輯員工',
        access: {
            stock: '庫存',
            add_product: '新增商品',
            edit_product: '編輯商品',
            delete_product: '刪除商品',
            view_capital_price: '檢視成本價',
            add_category: '新增類別',
            edit_category: '編輯類別',
            delete_category: '刪除類別',
            add_supplier: '新增供應商',
            edit_supplier: '編輯供應商',
            delete_supplier: '刪除供應商',
            add_customer: '新增客戶',
            edit_customer: '編輯客戶',
            delete_customer: '刪除客戶',
            add_staff: '新增員工',
            edit_staff: '編輯員工',
            delete_staff: '刪除員工',
            change_business_profile: '變更商家資料',
            access_by_product_category: '依商品類別存取',
            no_category_message: '您尚未新增任何類別，請先新增類別清單。',
            expenses: '支出',
            view_expenses: '檢視支出',
            add_expenses: '新增支出',
            edit_expenses: '編輯支出',
            delete_expenses: '刪除支出',
            warehouse: '倉庫',
            add_new_warehouse: '新增倉庫',
            edit_warehouse: '編輯倉庫',
            delete_warehouse: '刪除倉庫',
            transfer_warehouse: '倉庫轉移',
            transfer_warehouse_approval: '倉庫轉移審批',
            access_by_warehouse: '依倉庫存取',
            no_warehouse_message: '您尚未新增任何倉庫，請先新增倉庫清單。',
            purchase_order: "採購訂單",
            purchase_order_creation: "採購訂單建立",
            purchase_order_edit: "採購訂單編輯",
            purchase_order_cancel: "採購訂單取消",
            purchase_order_reopen: "採購訂單重新開啟",
            purchase_order_receive: "採購訂單接收",
            sales_order: "銷售訂單",
            sales_order_creation: "銷售訂單建立",
            sales_order_edit: "銷售訂單編輯",
            sales_order_cancel: "銷售訂單取消",
            sales_order_reopen: "銷售訂單重新開啟",
            sales_order_receive: "銷售訂單已出貨",
            purchase_order_approval: "採購訂單審批",
            sales_order_approval: "銷售訂單審批",
            can_do_available_warehouse: "可用倉庫",
            add_batch: "批次建立審批"
            ,
            notification: '通知',
            staffNotification: '啟用通知',
            assignee: "負責人",
        },
        no_staff: '尚無員工。'
    },
    code: {
        title: '已新增員工！',
        subtitle: '請分享下方邀請碼讓員工加入：',
        valid: '此碼僅有效 48 小時',
        share: '分享至 WhatsApp',
        copied: '已複製！',
        invalid: '無效的邀請碼！'
    },
    history: {
        no_history: '尚無歷史紀錄。',
        detail: {
            remove: '移除歷史紀錄',
            confirm: '此操作將影響現有庫存、歷史紀錄與報表。'
        },
        no_history_selected: "未選擇任何歷史記錄",
        select_history_hint: "點擊列表中的歷史記錄以查看詳細資訊",
        select_from_left: "從左側面板選擇",
    },
    supplier: {
        add: {
            title: '新增供應商'
        },
        edit: {
            title: '編輯供應商'
        },
        new: '新增供應商',
        no_supplier: '尚無供應商。',
        bank: {
            title: '銀行資訊'
        },
        note: '備註',
        form: {
            name: {
                label: '供應商名稱',
                placeholder: '輸入供應商名稱',
                placheolder_not_mandatory: '輸入名稱',
                error: {
                    required: '名稱不得為空'
                }
            },
            contact: {
                label: '聯絡電話',
                placeholder: '91934554432',
                error: {
                    required: '聯絡電話不得為空',
                    invalid: '號碼無效，請包含國碼'
                }
            },
            bank_name: {
                label: '銀行名稱',
                placeholder: '輸入銀行名稱'
            },
            bank_account_name: {
                label: '帳戶持有人姓名',
                placeholder: '輸入帳戶持有人姓名'
            },
            bank_account_number: {
                label: '帳號',
                placeholder: '輸入帳號'
            },
            note: {
                label: '備註',
                placeholder: '新增備註'
            },
            openingBalance: {
                addBtn: '新增期初餘額',
                label: '期初餘額',
                placeholder: '輸入期初餘額',
                error: {
                    negative: '期初餘額不能為負數'
                }
            }
        },
        choose: '選擇供應商'
    },
    customer: {
        add: {
            title: '新增客戶'
        },
        edit: {
            title: '編輯客戶'
        },
        new: '新增客戶',
        no_customer: '尚無客戶。',
        note: '備註',
        form: {
            name: {
                label: '客戶名稱',
                placeholder: '輸入客戶名稱',
                placheolder_not_mandatory: '輸入名稱',
                error: {
                    required: '名稱不得為空'
                }
            },
            contact: {
                label: '聯絡電話',
                placeholder: '91934554432',
                error: {
                    required: '聯絡電話不得為空',
                    invalid: '號碼無效，請包含國碼'
                }
            },
            address: {
                label: '地址',
                placeholder: '輸入地址'
            },
            note: {
                label: '備註',
                placeholder: '新增備註'
            },
            openingBalance: {
                addBtn: '新增期初餘額',
                label: '期初餘額',
                placeholder: '輸入期初餘額',
                error: {
                    negative: '期初餘額不能為負數'
                }
            }
        },
        choose: "選擇客戶",
        report: {
            view: '查看買家報表',
            title: '客戶報表',
            no_report: '所選日期無客戶報表資料。',
            column: {
                name: '名稱',
                total_transaction: '總交易筆數',
                total_amount: '總銷售額',
                total_profit: '總利潤'
            }
        }
    },
    confirm_delete: '確定要刪除此資料嗎？',
    report: {
        title: '報表'
    },
    accounting: {
        download_pdf_report: '下載PDF',
        title: '會計',
        view_report: '查看財務報表',
        dashboard_title: '財務報表',
        stats: '統計數據',
        accounting_report: '會計報表',
        filter: {
            date: {
                placeholder: '選擇日期',
                submit: '套用',
                cancel: '重設篩選'
            },
            timeframe: {
                day: '每日',
                week: '每週',
                month: '每月',
                year: '每年'
            }
        },
        total_sales: '總銷售額',
        total_purchases: '總進貨額',
        total_profit: '總利潤',
        total_expenses: '總支出',
        assets_value: '目前資產價值',
        total_current_cogs_value: '目前總COGS價值',
        current_asset_selling_price: '目前資產售價',
        total_selling_price: '總售價',
        table: {
            date: '日期',
            sales: '銷售',
            purchases: '進貨',
            profit: '利潤',
            expenses: '支出'
        },
        no_data: '無資料。'
    },
    stock_report: {
        title: '庫存報表',
        view: '查看庫存報表',
        no_report: '所選日期或員工無庫存紀錄。',
        allStaffPlaceHolder: '所有員工',
        column: {
            total_product: '目前商品種類',
            total_product_quantity: '目前商品總數'
        }
    },
    subscription: {
        paywall_small: {
            title: 'VIP 功能',
            description:
                '此功能的試用期已結束。請訂閱支持這款在地應用程式的持續開發。',
            button: '查看訂閱方案'
        }
    },
    payment: {
        order: {
            title: '付款'
        }
    },
    imageUploadMessage: {
        uploadSize: '圖片大小不得超過 5MB！',
        failedMessage: '商品圖片上傳失敗，請再試一次！',
        successUpload: '圖片上傳成功！',
        failedUIError: '圖片刪除失敗，請再試一次！',
        SuccessErrorImage: '圖片已成功刪除！'
    },
    productColumns: {
        SKULabel: 'SKU',
        nameLabel: '商品名稱',
        categoryLabel: '類別',
        BuyingPriceLabel: '進貨價',
        SellingLabel: '售價',
        StockLabel: '庫存'
    },
    historyColumns: {
        Transactionlabel: '交易類型',
        Locallabel: '本地時間',
        Createdlabel: '建立者',
        Vendorlabel: '供應商名稱',
        Buyerlabel: '買家名稱',
        SKUlabel: 'SKU',
        Invoicelabel: '發票',
        Productlabel: '商品名稱',
        Categorylabel: '類別',
        Buyinglabel: '進貨價',
        Sellinglabel: '售價',
        Initiallabel: '初始庫存',
        Finallabel: '最終庫存',
        Stocklabel: '庫存變動'
    },
    stockReportColumns: {
        skuLabel: 'SKU',
        productNameLabel: '商品名稱',
        categoryLabel: '類別',
        buyingPriceLabel: '進貨價',
        sellingPriceLabel: '售價',
        stockInLabel: '進貨',
        stockOutLabel: '出貨',
        remainingStockLabel: '剩餘庫存',
        openStockLabel: '初始庫存',
        weightedAverageCost: '加權平均成本',
        weightedAverageCostLabel: '加權平均成本',
        weightedAverageValueLabel: '加權平均值'
    },
    accountingReportColumns: {
        dateRange: '日期範圍',
        reportingPeriod: '報告期間',
        reportGenerate: '報告生成',
        warehouse: '倉庫',
        labelDate: '日期',
        labelSales: '銷售額',
        labelPurchases: '進貨額',
        labelProfit: '利潤',
        labelExpenses: '支出',
        reportOptions: '報告欄位',
        summaryCards: '摘要卡片',
        grandTotal: '總計',
        continued: '續',
        subtotal: '小計',
        page: '頁'
    },
    customerReportColumns: {
        labelName: '名稱',
        labelTotalTransaction: '總交易筆數',
        labelTotalSales: '總銷售額',
        labelTotalProfit: '總利潤'
    },
    scannerDialog: {
        finished: '完成',
        reduce: '減少',
        successfull: '成功',
        searching: '搜尋中...',
        title: '掃描器已啟動，請對準條碼！'
    },
    historyFilter: {
        SelectBuyer: '選擇買家',
        SelectVendor: '選擇供應商'
    },
    productStockFilter: {
        StockLowtoHigh: '庫存由低到高',
        StockHightoLow: '庫存由高到低',
        AlphabetAZ: '字母 A-Z',
        AlphabetZA: '字母 Z-A'
    },
    minimizeTitle: '掃描器運作中',
    security_guarantee: {
        title: '資料安全有保障'
    },
    invoice: {
        invoicePlaceholder: '發票號碼',
        invoiceTitle: '發票',
        manageInvoiceAddress: '管理發票地址',
        selectOrManageAddresses: '選取、編輯或建立自訂發票地址',
        useBusinessProfileAddress: '使用商業設定檔地址',
        noCustomAddressesFound: '未新增自訂地址',
        createCustomAddressDesc: '新增自訂帳單或分支機構地址以列印在發票上，替代預設的商業設定檔資料。',
        defaultFromBusinessProfile: '商業設定檔預設值',
        editInvoiceAddress: '編輯發票地址',
        createNewInvoiceAddress: '建立新發票地址',
        logoHeaderImage: '標誌 / 頁首圖片',
        deleteInvoiceAddress: '刪除發票地址？',
        deleteAddressConfirmText: '確定要刪除此發票地址嗎？此操作無法復原。'
    },
    ManageInvoiceAddress: '管理發票地址',
    SelectOrManageAddresses: '選取、編輯或建立自訂發票地址',
    UseBusinessProfileAddress: '使用商業設定檔地址',
    CreateNewAddress: '建立新地址',
    UpdatingList: '正在更新清單...',
    NoCustomAddressesFound: '未新增自訂地址',
    CreateCustomAddressDesc: '新增自訂帳單或分支機構地址以列印在發票上，替代預設的商業設定檔資料。',
    DefaultFromBusinessProfile: '商業設定檔預設值',
    EditInvoiceAddress: '編輯發票地址',
    CreateNewInvoiceAddress: '建立新發票地址',
    LogoHeaderImage: '標誌 / 頁首圖片',
    UploadingImage: '正在上傳圖片...',
    UploadImage: '上傳圖片',
    BusinessName: '企業名稱',
    AddressDetails: '地址詳細資料',
    PhoneNumber: '電話號碼',
    EmailAddress: '電子郵件地址',
    DeleteInvoiceAddress: '刪除發票地址？',
    DeleteAddressConfirmText: '確定要刪除此發票地址嗎？此操作無法復原。',

    stocklowreport: {
        no_stocklowreport_one: '尚未設定安全庫存的商品。',
        no_stocklowreport_two: '請新增安全庫存數量。',
        currentStock: '目前庫存',
        safetyStock: '安全庫存',
        pricing: '定價',
        costPrice: '成本價',
        sellingPrice: '售價',
        productInfo: '產品資訊',
        category: '類別',
        description: '描述',
        no_description: '尚未新增描述',
        variants: '變體',
        unitsOnHand: '現有庫存單位',
        minimumThreshold: '最低門檻',
        adjust: '調整',
        all: '全部',
        lowStock: '庫存不足',
        variantsDetails: '變體詳細資訊',
        qty: '數量',
        addSafetyStock: '新增安全庫存',
        searchByNameSku: '依名稱/SKU 搜尋',
        safetyStockShort: '安',
        warehouseSafetyStock: '倉庫安全庫存'
    },
    low_alert_stock: '輸入安全庫存數量',
    lowStockAlertNotify: '當庫存低於設定數量時，您將收到通知',
    applyButtonStockAlert: '套用',
    cancelButtonStockAlert: '取消',
    searchProductLabel: '搜尋商品...',
    successfullyAddedSafetyStock: '安全庫存更新成功',
    safety_Stock: '安全庫存',
    safety_stock_placeholder: '輸入安全庫存數量',
    lowStockDetailsInfo: {
        ProductCode: '商品編碼',
        SafetyStock: '安全庫存',
        Stock: '庫存',
        CostPrice: '成本價',
        SellingPrice: '售價',
        Category: '類別',
        Description: '描述',
        ExpirationDate: '到期日期'
    },
    CustomLang: {
        Attribute: '屬性',
        AddAttribute: '新增屬性',
        EditAttribute: '編輯屬性',
        CustomLabePlaceholder: '輸入屬性名稱',
        CustomLabePlaceholderSelect: '選擇類型',
        AddMoreAttribute: '新增更多屬性',
        ItemAttribute: '項目屬性',
        TableName: '名稱',
        TableType: '類型',
        TableAction: '操作',
        TableDelete: '刪除',
        TableEdit: '編輯',
        deleteMessage: '屬性刪除成功',
        editSuccessMessage: '屬性更新成功',
        AddSuccessMessage: '屬性新增成功',
        AddAtt: '新增',
        EditAtt: '編輯',
        SubmitAtt: '送出中...'
    },
    Expenses: {
        ExpensesTitle: '支出',
        AddExpenses: '新增支出',
        ExpenseCategory: '支出類別',
        NoExpenseCategory: '尚無支出類別',
        AddExpenseCategory: '新增支出類別',
        SelectExpenseCategory: '選擇支出類別',
        NoExpenses: '尚無支出紀錄',
        ExpensesSuccess: '支出新增成功',
        ExpensesSuccessEdit: '支出更新成功',
        ExpensesCategoryName: '支出類別名稱',
        ExpensesSuccessDelete: '支出刪除成功',
        AddNEC: '新增支出類別',
        NC: '新支出類別',
        EditNEC: '編輯支出類別'
    },
    Manufacturing: {
        ProducedProduct: "產出產品",
        QuantityManufactured: "製造數量",
        UnitCost: "單位成本",
        RawMaterialsTotal: "原材料總計",
        TotalManufacturingCost: "總製造成本",
        NoRawMaterialsConsumed: "未消耗原材料。",
        CostBreakdown: "成本明細",
        GeneratedBatch: "生成批次",
        StoredBinLocation: "存儲庫位",
        NoManufacturingTransactionsFound: "未找到製造交易記錄",
        AddManufacture: '新增製造明細',
        Manufacturing: '製造',
        RawMaterials: '原料',
        AdditonCosts: '額外成本',
        RawMaterial: '原料',
        AdditonCost: '額外成本',
        TotalCost: '總成本',
        AddRawMaterial: '為...新增原料',
        AddAdditonCost: '為...新增額外成本',
        AddMore: '新增更多',
        Add: '新增',
        Update: '更新',
        Updating: '送出中...',
        ProductRequired: '商品為必填',
        QuantityRequired: '數量為必填',
        ChargeRequired: '費用為必填',
        EstimatedCostRequired: '預估成本為必填',
        PurchasePriceRequired: '進貨價格為必填',
        SelectCharge: '選擇費用項目',
        EstimatedCost: '預估成本',
        SelectProduct: '選擇商品',
        Quantity: '數量',
        ManufactureDetails: '製造明細',
        BuyingPrice: '進貨價',
        LabourCharge: '人工費用',
        ElectricityCost: '電費',
        PackagingCharge: '包裝費用',
        LogisticCost: '物流費用',
        OtherCharges: '其他費用',
        Save: '儲存明細',
        PurchasePrice: '進貨價格',
        Date: '日期',
        For: '對象',
        PurchaseRate: '進貨單價',
        Scrolltoloadmore: '向下捲動載入更多...',
        Noproductsfound: '未找到商品',
        ManufacturingQuantity: '製造數量',
        ManufactureAddedSuccess: '製造明細更新成功'
    },
    Warehouses: {
        transferOrder: '轉移項目',
        AddTransferOrder: '新增轉移項目',
        NewWarehouse: '新倉庫',
        newHead: '開始管理多個倉庫！',
        headTwo: '輕鬆追蹤與管理多倉庫的庫存',
        EnableWarehouse: '啟用倉庫',
        EnableWarehouse2: '啟用倉庫功能',
        OrganizationPrimary: '組織主要倉庫',
        Edit: '編輯',
        AreEnableWarehouse: '確定要啟用倉庫嗎？',
        Confirm: '確認',
        Cancel: '取消',
        WarehouseCreatedSuccessfully: '倉庫建立成功',
        MarkAsOP: '標記為組織主要倉庫',
        MarkAsInAct: '標記為停用',
        MarkAsAct: '標記為啟用',
        MarkedAsInactive: '倉庫已標記為停用',
        MarkedAsActive: '倉庫已標記為啟用',
        MarkedAsOP: '倉庫已標記為組織主要倉庫',
        WareDeletedSuccess: '倉庫刪除成功',
        SuccessfullyUpdatedWarehouse: '倉庫更新成功',
        SuccessfullyCreatedWarehouse: '倉庫建立成功',
        EditWarehouse: '編輯倉庫',
        AddWarehouse: '新增倉庫',
        WarehouseNameIsRequired: '倉庫名稱為必填',
        EnterWarehouseName: '輸入倉庫名稱',
        EnterEmail: '輸入電子郵件',
        EnterPhoneNumber: '輸入電話號碼',
        Location: '位置...',
        name: '倉庫名稱',
        email: '電子郵件',
        phoneNumber: '電話號碼',
        location: '位置',
        ViewProducts: '查看商品',
        PageTitle: '倉庫管理',
        noWarehouse: "沒有倉庫符合您的搜尋"
    },
    Assets: {
        headerTitle: '資產',
        addAssetMessage: '在此新增資產。若要指派資產給員工，請至員工個人資料頁面操作。',
        addAsset: '新增資產',
        editAsset: '編輯資產',
        assetCode: '資產編碼',
        assetName: '資產名稱',
        assetCategory: '資產類別',
        assetType: '資產類型',
        serialNumber: '序號',
        location: '位置',
        condition: '狀況',
        selectCondition: '選擇狀況',
        fair: '普通',
        good: '良好',
        excellent: '極佳',
        poor: '差',
        notes: '備註',
        submit: '送出',
        submitting: '送出中',
        noCategory: '尚無類別',
        selectCategory: '選擇類別',
        addAssetCat: '新增資產類別',
        addAssetCatName: '資產類別名稱',
        edit: '編輯',
        status: '狀態',
        createdAt: '建立時間',
        viewAsset: '查看資產',
        assignAsset: '指派資產',
        conditionRet: '歸還時狀況',
        searchSelectAssets: '搜尋／選擇資產',
        assetAssigned: '資產指派成功',
        assetReturned: '資產歸還成功',
        selectAnAsset: '請選擇資產',
        action: '操作',
        noAssetAssigned: '尚未指派資產',
        reAssigned: '重新指派',
        assignedAssetsList: '已指派資產清單',
        viewHistory: '查看歷史',
        history: '資產歷史紀錄',
        loadingHistory: '載入歷史紀錄...',
        loadingMore: '載入更多...',
        dateTime: '日期與時間',
        staff: '員工',
        AssignedBy: '指派者',
        assign: '指派',
        return: '歸還',
        unknown: '未知',
        noHistory: '此資產尚無歷史紀錄。',
        enterReturnNote: '輸入歸還備註',
        returnNote: '歸還備註',
        enterAssignNote: '輸入指派備註',
        assignNote: '指派備註',
        AddNAC: '新增資產類別',
        EditNAC: '編輯資產類別',
        others: '其他'
    },
    LedgerTransaction: {
        ledgerDetails: '分類帳明細',
        productName: '商品名稱',
        totalQty: '總數量',
        date: '日期',
        receivedAmt: '已收金額',
        paid: '已付',
        discount: '折扣',
        balance: '餘額',
        more: '更多',
        total: '合計',
        ledgerupdatedsuccessfully: '分類帳更新成功',
        ledgeraddedsuccessfully: '分類帳新增成功',
        viewLedger: '查看分類帳',
        edit: '編輯',
        create: '建立',
        Recieved: '已收貨 [進貨]',
        payMode: '付款方式',
        Refno: '參考編號'
    },
    ExtraField: {
        attachment: '附件',
        acceptOnlyImg: '僅接受圖片檔案。',
        addAttribute: '新增屬性',
        acceptImgAndDoc: '接受圖片與文件檔案。'
    },
    phoneInvoiceDownload: {
        Variant: '變體',
        Warehouse: '倉庫',
        Bin: '儲位',
        Batch: '批次',
        Attributes: '屬性'
    },
    ImportExcel: {
        ImportStockfromExcel: '從 Excel 匯入庫存',
        DragDrop: '拖曳已填寫的 Excel 檔案至此，或點擊瀏覽',
        DT: '下載範本',
        GB: '返回',
        Downloading: '下載中...',
        ChangeFile: '更換檔案',
        ReadingExcelfile: '正在讀取 Excel 檔案...',
        Processing: '處理中...',
        submitUpdateStock: '送出並更新庫存',
        downloadLatestTemplate: '下載最新範本',
        loginRequired: '需要登入'
    },
    stockForm: {
        recordPaymentNow: "立即記錄付款",
        recordPaymentDescCustomer: "輸入客戶支付的金額",
        recordPaymentDescSupplier: "輸入供應商支付的金額",
        managePayments: "管理付款",
        invoice: "發票",
        challan: "出貨單",
        recordPayment: "記錄付款",
        payableAmount: "應付金額",
        paidAmount: "已付金額",
        paymentMethod: "付款方式",
        paymentDate: "付款日期",
        reference: "參考編號",
        billId: "帳單號碼",
        importExcel: "從 Excel 匯入",
        noThanks: "不用了，謝謝",
        checkHistory: "查看您的歷史紀錄",
        wantViewHistory: "是否要查看歷史紀錄？",
        enterPayable: '輸入應付金額',
        enterPaid: '輸入已付金額',
        selectPayment: "選擇付款方式",
        attachment: "附件",
        note: "備註"
    },
    HistoryEdit: {
        products: "商品",
        add_product: "新增商品",
        paidAmountInvalidMessage: '已付金額不得大於應付金額',
        removingText: "移除此商品將會還原此交易期間的庫存變動。",
        remove: "移除",
    },
    ExcelProduct: {
        uploadFile: "上傳檔案",
        dragDrop: "拖曳您的 Excel 檔案至此，或點擊上傳。",
        parsingFile: "正在解析檔案",
        fileSelected: "已選擇檔案",
        reviewImportedData: "請在下方檢視匯入的資料，欄位已盡可能自動對應。",
        changeFile: "更換檔案",
        back: "返回",
        invalidFileType: "請上傳有效的 Excel 檔案（.xlsx 或 .xls）",
        parseExcelError: "Excel 解析錯誤：",
        noData: "上傳的 Excel 檔案無資料。",
        failedToRead: "無法讀取 Excel 檔案，請再試一次。",
        Nodata: "無資料",
        unableToRead: "無法讀取檔案。",
        buyingMustNumber: "進貨價必須為數字",
        sellingMustNumber: "售價必須為數字",
        mustBeNumber: "必須為數字",
        bulkUploadfailed: "批量上傳失敗",
        importFromExcel: "從 Excel 匯入",
        generating: "產生中...",
        downloadTemplate: "下載範本",
        uploading: "上傳中...",
        done: "完成",
        requiredField: "{field} 為必填",
        bulkUpload: "批量上傳",
        duplicateSku: "發現重複的 SKU",
        uploadedSuccessfully: "所有產品已成功上傳！",
        uploadCompleteIssues: "上傳完成但有問題",
        uploaded_products: "已上傳 {count} 個產品。",
        failed_products: "{count} 個失敗。",
        failed_items: "失敗項目："
    },
    ProductForm: {
        barcodeQuantity: "輸入條碼數量",
        baseUnit: "基本單位（主單位）",
        addSecondaryUnit: "是否新增次單位？",
        selectUnit: "選擇單位",
        subUnitDetails: "次單位詳細資訊",
        subUnit: "次單位",
        selectSubUnit: "選擇次單位",
        conversionRate: "轉換比率",
        exampleLogic: "範例邏輯：",
        example: "若您以箱為單位銷售原子筆，可將基本單位設為「箱」，新增次單位「支」，轉換比率設為 50，即表示 1 箱 = 50 支。",
        basePrice: "基本價格",
    },
    barcode: {
        settings: '條碼設定',
        labelSize: '標籤尺寸',
        customSize: '自定義尺寸...',
        widthMm: '寬度 (mm)',
        heightMm: '高度 (mm)',
        showPrice: '在標籤上顯示售價',
        noPrices: '未為此產品配置售價。',
        preview: '預覽',
        generate: '生成',
        label: '標籤',
        singlePage: '單頁',
        downloadOptions: '下載選項',
        chooseLayout: '選擇條碼佈局',
        allInSinglePage: '將所有條碼添加到單頁中。',
        allInA4Grid: '全部在一頁中',
        allInA4GridSub: '將所有條碼排列在 A4 網格中',
        onePerPage: '每頁一個',
        onePerPageSub: '每個條碼位於其自己的標籤頁'
    },

    Discount: {
        overallDiscount: "整體折扣",
        final: '最終金額',
        balanceDue: "尚欠金額",
        tax: "稅金",
    },
    TransferItem: {
        transferItem: '轉移項目',
        Date: '日期',
        Reason: '原因',
        enterReason: "輸入原因",
        Name: '名稱',
        QuantityTransfered: '轉移數量',
        SWarehouse: '來源倉庫',
        SelectSWarehouse: '選擇來源倉庫',
        DWarehouse: '目的倉庫',
        SelectDWarehouse: '選擇目的倉庫',
        CreatedBy: '建立者',
        CreatedTime: '建立時間',
        UpdatedTime: '更新時間',
        NoOrderFound: '未找到訂單',
        New: '新增',
        WarehouseItemTransfer: '倉庫項目轉移',
        TotalTransfers: "總轉移數",
        EnterReason: '輸入原因',
        ItemDetails: '項目詳細資訊',
        CurrentAvailable: '目前可用量',
        TransferQty: '轉移數量',
        SStock: '來源庫存',
        DStock: '目的庫存',
        addDescription: "為項目新增描述",
        selectVariant: "選擇變體",
        addNewRow: "新增一行",
        typeOrSelectItem: "輸入以搜尋",
        scrollToLoadMore: "向下捲動載入更多",
        noProductsFound: "未找到商品",
        selectWarehouse: "選擇倉庫"
    },
    Sku: {
        searchSelectProduct: "搜尋／選擇商品",
        searchSelectSku: "搜尋／選擇 SKU",
        noSkuFound: "未找到 SKU"
    },
    HistoryPage: {
        addFilter: "新增篩選",
        filtersActive: "所有篩選條件已啟用",
        noProducts: "無商品",
        download: "下載",
        recentlyUpdated: "最近更新",
    },
    StockPage: {
        challanNumber: "出貨單號碼",
        subTotal: "小計",
        totalTaxes: "合計與稅金",
        taxInclusive: "含稅",
        discountedValue: "折扣金額",
        taxValue: "稅金金額",
        totalAmount: "總金額",
        close: "關閉",
        addTax: "新增稅率",
        label: "稅率名稱",
        enterLabel: "輸入稅率名稱",
        taxRate: "稅率",
        enterTaxRate: "輸入稅率",
        selectTaxRate: "選擇稅率",
        addNewTax: "新增稅率",
        discountProducts: "折扣金額（商品）",
        taxProducts: "稅金金額（商品）",
        clickAddPayment: "點擊新增付款",
        paidGreaterPayable: "已付金額不得大於應付金額",
        vendorCompulsory: '記錄付款需選擇供應商',
        customerCompulsory: "記錄付款需要選擇客戶",
        updateInvoiceFormat: "更新發票格式",
        updateChallanFormat: "更新出貨單格式",
        addPrefix: "新增前綴",
        prefix: "前綴"
    },
    EditHistoryPage: {
        search_by_notes: "依備註搜尋",
        alertMessage: "此變更僅記錄於歷史紀錄，不影響目前商品庫存。",
        paymentDetails: "付款詳細資訊",
        units: "單位",
        customLabels: "自訂標籤",
        value: "值",
        Order_Info: "訂單資訊",
        percentage: "百分比",
        Stock_updates_on_submit: "提交时更新库存",
        Summary: "摘要"
    },
    historyCard: {
        paid: "已付清",
        partiallyPaid: "部分付款",
        billDate: "帳單日期",
        productDetails: "商品詳細資訊",
        paymentsHistory: "付款歷史",
        updatePayment: "更新付款",
        discounts: "折扣",
        inclusive: "(含稅)",
        discountOverall: "整體折扣金額",
        dueAmount: "尚欠金額",
        enterPaid: "輸入已付金額",
        enterReference: "輸入參考編號",
        enterNote: "輸入備註",
        enterInvoice: "輸入發票號碼",
        enterChallan: "輸入出貨單號碼",
        edit: "已編輯"
    },
    printInvoice: {
        billTo: "帳單對象",
        ref: "參考編號",
        mode: "付款方式",
        date: "日期",
        amount: "金額",
        totalPaid: "已付總額",
        noImage: "無圖片"
    },
    Contact: {
        supplier_required: "進貨需選擇供應商",
        customer_required: "出貨需選擇客戶",
        key: "鍵值",
        editHistory: "編輯歷史",
        loading: "載入中..."
    },
    AW: {
        availablewarehouse: "可用倉庫",
        visibilityManagement: '可見性管理',
        availablewarehouses: "可用倉庫",
        Active: "啟用中",
        LWarehouse: "載入倉庫中...",
        NWForthisProduct: "此商品無可用倉庫。",
        of: "的",
        WarehouseAvailabilty: "倉庫可用性",
    },
    Currency: {
        searchCurrency: "搜尋貨幣...",
        addCurrency: "新增貨幣",
        addNewCurrency: "新增貨幣",
        editCurrency: "編輯貨幣",
        currencySymbol: "貨幣符號",
        currencyName: "貨幣名稱",
        enterCurrencySymbol: "輸入貨幣符號",
        enterCurrencyName: "輸入貨幣名稱"
    },
    NewReportLang: {
        DM: "每日移動",
        WR: "倉庫報告",
        PDM: "產品每日移動",
        TBP: "總購買價格",
        TPQ: "總產品數量",
        TP: "總產品",
        CS: "目前庫存",
        IV: "庫存價值",
        DA: "每日平均",
        TSI: "總入庫",
        TSO: "總出庫",
        TOR: "周轉率",
        Tv: "總價值",
        AST: "活躍SKU追蹤",
        UT: "追蹤單位",
        SL: "庫存水準",
        Value: "價值",
        IO: "入庫/出庫",
        T: "周轉",
        unitsD: "單位/天",
        Sort: "排序",
        Sort_by: "依據排序",
        Units_available: "可用單位",
        Units_unavailable: "不可用單位",
        Current_assets: "流動資產",
        Search: "搜尋",
        available: "可用",
        assigned: "已指派",
        AYSWD: "確定要刪除嗎？",
        PTS: "倉庫轉移成功",
        AUS: "資產更新成功",
        ACS: "資產建立成功",
        VSP: "查看銷售價格",
        HUS: "歷史記錄更新成功",
    },
    ReplacementReturn: {
        selectProduct: "請選擇商品",
        selectReplacementProduct: "請至少選擇一個替換商品",
        validQuantity: "請輸入有效的退貨數量",
        replacedSuccessfully: "商品替換成功",
        returnSuccessfully: "商品退貨成功",
        failedProcess: "處理失敗，請再試一次。",
        return: "退貨",
        replace: "替換",
        typeSelectProduct: "輸入或選擇商品...",
        returnQuantity: "退貨數量",
        enterQuantity: "輸入數量",
        replacementDate: "替換日期",
        returnDate: "退貨日期",
        chooseCustomer: "選擇客戶",
        additionalNotes: "新增額外備註...",
        replacementProducts: "替換商品",
        addProducts: "新增更多商品",
        tapSelect: "點擊從可用商品中選擇",
        currently: "目前",
        item: "件",
        items: "件",
        selected: "已選",
        selectedItems: "已選項目",
        hideDetails: "隱藏更多細節",
        showDetails: "顯示更多細節",
        product: "商品",
        priceLevel: "選擇價格等級",
        customPrice: "輸入自訂價格",
        noReplaceHistory: "未找到替換記錄",
        replaceReturn: "更換與退貨",
        replaceReturnHistory: "更換與退貨紀錄"
    },
    OtherComponent: {
        mfgHistoryTitle: "製造歷史",
        mfgHistoryDesc: "跟蹤製造的庫存產品",
        dailyOperation: "日常營運",
        freqUsed: "用於快速更新記錄的常用操作",
        manageCategory: "管理分類",
        organizeCaterory: "整理和管理產品、費用與資產分類",
        businessRecord: "業務記錄",
        organizeRecord: "整理和管理您的業務記錄",
        trackHistory: "追蹤歷史",
        completeTracking: "用於稽核和追蹤的完整歷史記錄",
        Verifyinventorycount: "驗證庫存數量",
        Exchangerates: "匯率",
        Productiontracking: "生產追蹤",
        Fixedassetregister: "固定資產登記冊",
        Storagelocations: "儲存位置",
        warehouseAvailability: '倉庫級產品供應情況',
        Logreviewspend: "記錄並檢視支出",
        Productgroupings: "產品分組",
        Classifyexpenditures: "支出分類",
        Assetclassification: "資產分類",
        Manageexchanges: "管理匯率",
        Returnauditlog: "退貨稽核日誌",
        Interlocationmoves: "位置間移動",
        Manageoperationscategoriesrecordsandhistory: "管理營運、分類、記錄與歷史"
    },
    no_permission_dialog: {
        title: '無權限',
        historyDescription: "您無權限檢視交易記錄。請聯絡您的管理員。",
        replacementHistoryDescription: "您無權限檢視替換與退貨記錄。請聯絡您的管理員。",
        transferHistoryDescription: "您無權限檢視轉倉記錄。請聯絡您的管理員。"
    },
    OthersHistory: {
        title: "管理歷史",
        transferHistory: "管理轉倉歷史",
        transactionHistory: "管理交易歷史",
        replacementHistory: "管理替換與退貨歷史"
    },
    catalog: {
        allCategories: "All",
        category: "Category",
        purchaseDescription: "瀏覽並購買企業分享的產品。",
        description: "瀏覽企業分享的產品。",
        productsAvailable: "可用產品",
        noImageAvailable: "沒有可用圖片",
        productDetails: "產品詳情",
        inStock: "有庫存",
        availableVariants: "可用選項",
        options: "選項",
        orders: "訂單"
        ,
        searchProducts: "搜尋商品...",
        noProductsFound: "找不到商品",
        tryDifferentKeyword: "嘗試用其他關鍵字搜尋",
        variants: "規格",
        stock: "庫存",
        cart: "購物車",
        products: "商品",
        viewCart: "查看購物車",
        backToProducts: "回到商品",
        yourCart: "你的購物車",
        clear: "清除",
        cartEmpty: "購物車是空的",
        cartEmptyDesc: "瀏覽目錄並加入想訂購的商品。",
        browseProducts: "瀏覽商品",
        selectedItems: "已選商品",
        itemInCart: "項商品在購物車",
        itemsInCart: "項商品在購物車",
        customerDeliveryDetails: "客戶與配送資料",
        fullName: "姓名",
        enterFullName: "請輸入姓名",
        deliveryAddress: "配送地址",
        addressPlaceholder: "街道、大樓、城市、郵遞區號...",
        orderNote: "訂單備註（選填）",
        orderNotePlaceholder: "特殊需求或配送備註...",
        paymentMode: "付款方式",
        subtotal: "小計",
        items: "項",
        totalAmount: "總金額",
        orderOnWhatsApp: "透過WhatsApp訂購 📲",
        orderPlaced: "訂單已成功送出！🎉",
        orderPlacedDesc: "您的訂單已記錄，WhatsApp已開啟。",
        continueShopping: "繼續購物 🛍️",
        cartEmptyTitle: "購物車是空的",
        cartEmptyToast: "結帳前請先加入商品。",
        incompleteTitle: "資料不完整",
        incompleteToast: "下單前請填寫所有必填欄位。",
        nameRequired: "姓名為必填",
        addressRequired: "配送地址為必填",
        catalogUnavailable: "目錄暫時無法使用",
        catalogUnavailableDesc: "此目錄目前未啟用，請聯繫商家。",
        invalidCatalogLink: "無效的目錄連結 🚫",
        invalidCatalogDesc: "此目錄頁面缺少必要資訊。",
        missing: "缺少",
        catalogSlug: "目錄代碼",
        goBackHome: "返回首頁",
        inventoryManagement: "庫存管理與發票 🚀 Simply",
        enter: "輸入",
        select: "選擇",
        // Catalog Order translations
        catalogOrders: '目錄訂單',
        pending: '待處理',
        converted: '已轉換',
        cancelled: '已取消',
        totalRevenue: '總價值',
        totalCatalogOrders: '線上訂單總數',
        convertToSalesOrder: '轉換為銷售訂單',
        date: '日期',
        status: '狀態',
        action: '操作',
        searchOrders: '搜尋客戶或電話...',
        noMatchingOrders: '找不到相符訂單',
        noStatusOrders: '找不到{status}訂單',
        tryDifferentSearch: '嘗試使用不同的客戶名稱或電話號碼進行搜尋。',
        noOrdersWithStatus: '目前沒有{status}狀態的訂單。',
        noOrdersYet: '尚無目錄訂單',
        noOrdersDescription: '來自您線上目錄的訂單將顯示在這裡。',
        guestCustomer: '訪客客戶',
        item: '商品',
        moreItems: '+{count}個更多',
        viewDetails: '查看詳情',
        viewSalesOrder: '查看銷售訂單',
        cancelOrder: '取消訂單',
        confirmCancelTitle: '取消目錄訂單？',
        confirmCancelOrder: '您確定要取消此訂單嗎？此操作無法撤銷。',
        keepOrder: '否，保留訂單',
        confirmCancelAction: '是，取消訂單',
        orderNotFound: '找不到目錄訂單',
        orderNotFoundDescription: '找不到此訂單，或者您可能沒有查看權限。',
        backToCatalogOrders: '返回目錄訂單',
        placedOn: '下單時間',
        totalItems: '商品總數',
        orderedProducts: '已訂購產品',
        itemDetails: '商品詳情',
        quantity: '數量',
        unitPrice: '單價',
        total: '總計',
        variant: '款式',
        customerInformation: '客戶資訊',
        additionalFields: '附加欄位',
        fields: '欄位',
    },
    stockNew: {
        Npay: "尚未新增任何產品",
        emptydesc: "從您的目錄中選取一個產品，並輸入進貨數量以記錄庫存。",
        tipText: "提示：您也可以上傳 Excel 檔案",
        OT: "訂單總額",
        Collapse: "摺疊"
    },
    deleteBulk: {
        Bulkoperation: "批次操作",
        Applyproducts: "對多個商品套用動作",
        Bulkupload: "批次上傳",
        ImportCSVfile: "透過 Excel 或 CSV 檔案匯入商品",
        or: "或",
        Bulkdelete: "批次刪除",
        Permanentlyallproducts: "永久移除所有商品",
        IrrText: "批次刪除無法復原。如有需要，請先匯出備份。",
        SeP: "已選商品",
        sP: "選擇商品",
        DA: "全部刪除",
        DP: "刪除商品",
        sL: "全選",
        ASDE: "確定要刪除除了",
        ASDAllP: "確定要刪除所有商品嗎？",
        ASD: "確定要刪除",
        products: "個商品",
        TACBU: "此動作無法復原。",
        LP: "正在載入商品...",
        FM: "正在載入更多...",
        NPF: "找不到商品。",
        LMP: "正在載入更多商品..."
    },
    NewVariantModal: {
        Definevariantsassign: "定義變體並指派數量",
        Nothingallocated: "未指派任何數量",
        Overallocated: "超額指派",
        Fullyallocated: "已完全指派",
        Overby: "超額",
        Allvariantsneedaname: "所有變體都需要名稱。",
        Reducequantities: "減少數量。",
        Overallocatedby: "超額指派",
        Quantitiesmustmatchthetotalavailability: "數量必須與總可用量相符。",
        Allocatequantitiesacrosswarehouses: "跨倉庫指派數量",
        Notfullydistributed: "尚未完全分配：",
        remaining: "剩餘",
        Qty: "數量",
        Inactive: "未啟用",
        left: "剩餘"
    },
    ProductFormNew: {
        BasicInfo: "基本資訊",
        ProductImage: "商品圖片",
        Images: "圖片",
        Pricing: "定價",
        Everypriceneedsbothalabelandanamount: "每個價格都需要標籤與金額",
        AddalabellikeWholesaleorRetailtoidentifythisprice: '新增像是「批發」或「零售」的標籤來辨識此價格',
        AddMultiplePrice: "新增多個價格",
        NoPhotosLetAiFind: "沒有照片？讓 AI 尋找商品圖片",
        AddProductImagesTitle: "新增商品圖片",
        ChooseHowToAddPhotos: "選擇為此商品新增照片的方式：",
        SearchWithAi: "使用 AI 搜尋",
        SearchWithAiDesc: "使用 AI 自動尋找並選擇商品圖片",
        FilesFileExplorer: "檔案（檔案總管）",
        FilesFileExplorerDesc: "直接從您的電腦中選擇圖片",
        AiProductImageFinder: "AI 商品圖片尋找器",
        AiProductImageFinderDesc: "為您的商品搜尋並選擇圖片",
        TypeProductNamePlaceholder: "輸入商品名稱...",
        SearchForYourProduct: "搜尋您的商品",
        SearchForYourProductHint: `嘗試品牌或商品名稱，例如 "Kirkland 米諾地爾"`,
        ImagesSelected: "張圖片已選擇",
        AddSelected: "新增所選"
    },
    AttributeNewCustom: {
        Defineanewcustomfield: "定義新的自訂欄位",
        AttributeName: "屬性名稱",
        DataType: "資料類型",
        Noattributesfound: "找不到屬性",
        ManageAttributes: "管理屬性",
        Editordeleteexistingattributes: "編輯或刪除現有屬性",
        UpdateAttribute: "更新屬性",
        Saving: "儲存中..."
    },
    NewExpenses: {
        Noexpensesyet: "尚未有支出",
        Addyourfirstexpensetostarttrackingyourspending: "新增您的第一筆支出，開始追蹤您的花費。",
        TOTALEXPENSES: "總支出",
        ENTRIES: "項目",
        BYCATEGORY: "依類別",
        Nocategoriestodisplay: "無類別可顯示",
        DateanfTime: "日期與時間"
    },
    PurchaseSales: {
        CancelOrder: "取消訂單",
        ReopenOrder: "重新開啟訂單",
        Reopen: "重新開啟",
        ConfirmCancelOrder: "您確定要取消此訂單嗎？",
        ConfirmReopenOrder: "您確定要重新開啟此訂單嗎？",
        OrderCancelledSuccessfully: "訂單已成功取消。",
        OrderReopenedSuccessfully: "訂單已成功重新開啟。",
        CancelledBy: "取消者",
        Cancelled: "已取消",
        ConvertPriceBasedOnUnitConversion: "根據單位換算轉換價格",
        MarkPaymentAsPending: "將付款標記為待處理",
        PendingReceivableDesc: "金額已記錄為應收款。收到款項時記錄付款。",
        PendingPayableDesc: "金額已記錄為應付款。付款時記錄付款。",
        SelectCustomerFirst: "請先選擇客戶",
        SelectSupplierFirst: "請先選擇供應商",
        SelectItemsFirst: "請先選擇至少一項商品",
        PaymentMarkedPendingDesc: "付款已標記為待處理。取消勾選「將付款標記為待處理」以立即記錄付款。",
        SelectCustomerAndItemFirst: "請先選擇客戶和至少一個項目",
        SelectSupplierAndItemFirst: "請先選擇供應商和至少一個項目",
        SelectCustomerProductFirst: "請先選擇客戶和產品",
        SelectSupplierProductFirst: "請先選擇供應商和產品",
        Receivables: "應收帳款",
        Payables: "應付帳款",
        AccessDenied: "存取被拒",
        YouDonthaeP: "您沒有權限檢視此頁面。若認為這是錯誤，請聯絡您的管理員。",
        purchase: "採購",
        sales: "銷售",
        Areyousureyouwantto: "您確定要",
        Thisactionwillupdateitsstatus: "此動作將更新其狀態。",
        ReasonOPtional: "原因（選填）",
        Enterareasonfor: "請輸入原因",
        optionalDot: "(選填)...",
        Reject: "拒絕",
        ConfirmOrder: "確認訂單",
        RejectOrder: "拒絕訂單",
        Previous: "上一個",
        First: "第一個",
        Order: "訂單",
        Items: "商品",
        Memo: "備註",
        SelectDateRange: "選擇日期範圍",
        List: "清單",
        Board: "看板",
        View: "檢視",
        CreateSalesOrder: "建立銷售訂單",
        CreatePurchaseOrder: "建立採購訂單",
        successfully: "成功",
        ManageAttachments: "管理附件",
        Stockoutitemsimmediatelyaftersaving: "儲存後立即出庫商品。",
        Stockinitemsimmediatelyaftersavingthisorder: "儲存此訂單後立即入庫商品。",
        ViewAttachments: "檢視附件",
        MemoAttachments: "備註與附件",
        ReceivedDate: "接收日期",
        ShippedDate: "出貨日期",
        OrderDate: "訂單日期",
        OrderDetails: "訂單詳細",
        Subtotal: "小計",
        OrderSummary: "訂單摘要",
        AddItem: "新增商品",
        NewSalesOrder: "新銷售訂單",
        NewPurchaseOrder: "新採購訂單",
        Createandmanageyour: "建立與管理您的",
        orders: "訂單",
        Removeitem: "移除商品",
        UnitPrice: "單價",
        PurchaseOrder: "採購訂單",
        SalesOrder: "銷售訂單",
        PurchaseInvoice: "採購發票",
        SalesInvoice: "銷售發票",
        PurchaseOrdernotfound: "找不到採購訂單",
        Approve: "核准",
        MarkasShipped: "標記為已出貨",
        MarkasReceived: "標記為已接收",
        Marking: "標記中...",
        PartiallyShip: "部分出貨",
        PartiallyReceive: "部分接收",
        Deleting: "刪除中...",
        Transaction: "交易",
        Details: "詳細",
        Item: "商品",
        Received: "已接收",
        Shipped: "已出貨",
        Ordered: "已訂購",
        units: "單位",
        Overalldiscount: "總折扣",
        Transactions: "交易記錄",
        Notransactionsfound: "找不到交易",
        OrderedQty: "訂購數量",
        Totalqty: "總數量",
        StockingOut: "出庫中...",
        StockingIn: "入庫中...",
        thiorderUpdateStuau: "此訂單？此動作將更新其狀態。",
        TransactionDetails: "交易詳細",
        Fetchingtransactiondetails: "正在取得交易詳細...",
        Nodetailsfoundforthistransaction: "找不到此交易的詳細資訊。",
        TotalBreakDown: "總額明細",
        ChangeAmount: "找零金額",
        Attachments: "附件",
        PoNumber: "採購單號",
        SoNumber: "銷售單號",
        partner: "合作夥伴",
        EditPurchase: "編輯採購",
        EditSales: "編輯銷售",
        PurchaseOrderDetails: "採購訂單詳細",
        SalesOrderDetails: "銷售訂單詳細",
        OrderType: "訂單類型",
        SelectOrderType: "選擇訂單類型",
        OrderTypePrepaid: "預付款",
        OrderTypeCOD: "貨到付款",
        OrderTypePayLater: "稍後付款",
        OrderTypePartialPayment: "部分付款",
        OrderTypeSubscription: "訂閱",
        viewAvailabilty: '查看可用時段',
        NotReceived: "未收貨",
        NotShipped: "未出貨",
        PartiallyReceived: "部分收貨",
        PartiallyShipped: "部分出貨",
    },
    PriceReference: {
        HighPrice: "最高價",
        LowPrice: "最低價",
        LastPrice: "最新價",
        LastPurchasePrice: "最新採購價格",
        Nopricerecordsfound: "未找到價格記錄",
        BuyingPriceReference: "採購價參考",
        SellingPriceReference: "銷售價參考",
        Viewstockinpricesfortheselectedvendorandproduct: "查看所選供應商與產品的入庫價格",
        Viewstockoutpricesfortheselectedcustomerandproduct: "查看所選客戶與產品的出庫價格"
    },
    SubscriptionLocale: {
        premiumPlan: "高級方案",
        heading: "做出商業決策",
        headingHighlight: "基於資料",
        subtitle: "解鎖您商業分析的完整力量 — 無限制，無妥協。",
        choosePlan: "選擇您的方案",
        monthly: "每月",
        annual: "每年",
        oneTime: "一次性 (月租)",
        perMonth: "每月",
        perYear: "每年",
        bestValue: "最佳價值",
        continueWith: "繼續使用",
        perMonthShort: "月",
        perYearShort: "年",
        troubleWithSubscription: "訂閱遇到問題？",
        contactUs: "聯絡我們",
        paymentNotReady: "付款尚未準備好",
        checkoutError: "結帳錯誤",
        pricePreviewError: "價格預覽錯誤"
    },
    SubscriptionLocale2: {
        GoPro: "升級到 Pro",
        Makesmarterdecisionsbackedbyrealbusinessdata: "根據真實商業資料做出更明智的決策",
        ExploreProPlans: "探索 Pro 方案"
    },
    emptyWarehouseState: {
        tips: [
            "您可以為不同實體位置設置多個倉庫",
            "每個商品按倉庫獨立追蹤庫存",
            '使用「倉庫調撥」在不同位置之間移動庫存'
        ],
        NoWarehousesConfigured: "尚未設定任何倉庫",
        desc: "首先新增您的倉庫（如果有多個），然後新增商品並記錄庫存異動。",
        WarehouseSetupTips: "倉庫設定提示",
        Noproductselected: "尚未選擇商品",
        Selectaproductfromthelefttoviewlowstockdetails: "從左側選擇商品以查看低庫存詳細資料。",
        Chooseaproductfromthelist: "從清單中選擇商品",
        SelectProduct: "選擇商品",
        SetQuantity: "設定數量",
        Showing: "顯示中",
        products: "商品",
        Continue: "繼續",
        SaveSafetyStock: "儲存安全庫存",
        SafetyStockSaved: "安全庫存已儲存！",
        hasbeensetto: "已設定為",
        AddAnother: "新增另一個",
        Chooseaproduct: "選擇商品",
        Step: "步驟",
        of: "之",
        Setsafetyquantity: "設定安全數量",
        Complete: "完成",
        SafetyStockQuantity: "安全庫存數量",
        Minimumunitsdropsbelowthisnumber: "庫存中應始終保留的最低單位數。當庫存低於此數量時將觸發警示。",
        NewSafetyStock: "新的安全庫存",
        SafetyNow: "目前安全庫存",
        SettingTo: "正在設定為",
        Change: "變更",
        sell: "銷售",
        cost: "成本",
        BulUD: "大量上傳/刪除"
    },
    SimplyLoginUI: {
        sslEncryption: "256位 SSL 加密",
        dataPrivate: "您的資料 100% 私密",
        worksOnDevices: "支援 Android 與 iPhone",
        realTimeSync: "所有裝置即時同步",
        cloudBackup: "自動雲端備份",
        availableOn: "支援網頁、Android 與 iOS",
        tagline: "您的庫存，",
        taglineEm: "簡潔優雅。",
        subtitle: "登入即可管理庫存、追蹤銷售，讓您的業務順暢運作 —— 一切盡在一處。",
        feature1Title: "即時庫存追蹤",
        feature1Desc: "準確掌握每個倉庫的庫存情況，時刻保持最新。",
        feature2Title: "銷售與採購訂單",
        feature2Desc: "建立發票、管理供應商，並追蹤每一筆交易。",
        feature3Title: "智慧報表",
        feature3Desc: "財務、庫存與每日動態報表一目了然。",
        feature4Title: "所有裝置即時同步",
        feature4Desc: "手機上的變更會即時顯示在網頁上 —— 反之亦然。",
        rating1: "評分",
        rating2: "4.9/5",
        rating3: "來自 10,000 家批發企業",
        brandName: "Simply",
        greeting: "歡迎回來！👋",
        noPasswordNeeded: "登入即可存取您的庫存 —— Android、iPhone 與網頁，完全同步。",
        badge1: "庫存管理",
        badge2: "銷售追蹤",
        badge3: "報表",
        trustEncryptedTitle: "已加密",
        trustEncryptedSub: "256位 SSL",
        trustPrivateTitle: "私密",
        trustPrivateSub: "僅您的資料",
        trustBackedTitle: "已備份",
        trustBackedSub: "每日自動",
        availableOnLabel: "支援平台",
        platformAndroid: "Android",
        platformIphone: "iPhone",
        platformWeb: "網頁",
        syncBadge: "所有裝置即時同步",
        securityNote: "100% 安全。",
        securityDesc: "銀行等級加密保護您的所有資料。我們只會讀取您的姓名與電子郵件 —— 其他一無所知，永遠如此。",
        signingIn: "正在登入…",
        termsPrefix: "登入即表示您同意 Simply 的",
        privacyPolicy: "隱私權政策",
        and: "與",
        termsOfService: "服務條款",
        google: "使用 Google 登入"
    },
    BatchLocal: {
        BatchName: "批次名稱",
        EnterBatchName: "輸入批次名稱",
        EnterNotes: "輸入備註",
        ExpiredDate: "到期日期",
        Selectexpireddate: "選擇到期日期",
        BatchStatus: "批次狀態",
        CreatedDate: "建立日期",
        Areyousureyouwanttodeletethisbatch: "您確定要刪除此批次嗎？",
        Youhavencreatedanybatchforthisproduct: "您尚未為此產品建立任何批次。",
        Createyourfirstbatchtostarttrackingtockbylotexpiry: "建立您的第一個批次，開始按批次和到期日期追蹤庫存。",
        Nobatchesyet: "暫無批次",
        Whatisbatchmanagement: "什麼是批次管理？",
        Howithelpsyourbusiness: "它如何幫助您的業務",
        Trackbylotnumber: "按批號追蹤",
        Trackbylotnumberdesc: "按製造商批次對庫存進行分組，以便您始終知道每個單位來自哪個批次。",
        Expirydatecontrol: "到期日期控制",
        Expirydatecontroldesc: "在庫存到期前收到警報。先銷售較舊的批次，自動減少浪費。",
        Fulltraceability: "完全可追溯性",
        Fulltraceabilitydesc: "查看每筆交易中使用了哪個批次 — 非常適合稽核和召回。",
        Supplierwisestock: "按供應商劃分庫存",
        Supplierwisestockdesc: "即使是同一產品，也要將不同供應商的庫存分開。按批次比較品質。",
        Createyourfirstbatchbutton: "建立您的第一個批次",
        Nomatchesfound: "未找到匹配項",
        NomatchesfounddescBefore: "我們找不到與 ",
        NomatchesfounddescAfter: " 匹配的任何批次。",
        Clearsearch: "清除搜尋",
        Nohistoryfoundthisbatch: "此批次沒有找到歷史記錄",
        ComprehensiveDetails: "詳細資訊",
        History: "歷史記錄",
        InBatch: "在批次中",
        Noproductfoundinthisbatch: "此批次中未找到產品",
        SelectBatch: "選擇批次",
        available: "可用",
        Searchbatches: "搜尋批次...",
        Expires: "到期",
        Nobatchesfound: "未找到批次",
        ManageBatches: "管理批次",
        Batchmanagement: "批次管理",
        Trackstockexpiry: "按批次和到期日期追蹤庫存",
        Turnoffbatchmanagement: "關閉批次管理？",
        Yourgsafe: "您現有的批次資料將保持安全。",
        Reenableanytimefrom: "您可以隨時從",
        Otherstab: "其他選項卡",
        AddBatch: "新增批次",
        Total: "總計",
        AssignProduct: "分配產品",
        EditProductAssignment: "編輯產品分配",
        AssignProducttoBatch: "將產品分配到批次",
        Updateproductconfiguration: "更新產品配置",
        Step1of2: "第 1 步，共 2 步",
        Step2of2: "第 2 步，共 2 步",
        Selectvariantwarehouse: "選擇變體和倉庫",
        SelectedProduct: "已選產品",
        AssignQuantity: "分配數量",
        BatchInfo: "批次資訊",
        Wecouldnthisproductidentifier: "我們找不到與此產品識別碼關聯的任何批次。",
        NoActiveBatches: "沒有活動批次",
        Endofresults: "結果結束",
        Expiry: "到期",
        BatchManagementDescription: "透過批號與到期日期追蹤庫存。確保每次出庫時自動採用正確的 LIFO / FEFO 順序 — 無需手動挑選。",
        Expiryalerts: "到期提醒",
        Autonotifications: "自動通知",
        LIFOsorting: "LIFO / FEFO 排序",
        Smartstockflow: "智慧庫存流動",
        Perout: "逐批出庫",
        Precisiontracking: "精準追蹤",
        NeedsReview: "需要審核",
        Pending: "待處理",
        Rejected: "已拒絕",
        Approved: "已批准",
        WaitingForApproval: "等待批准",
        WaitingForApprovalDesc: "您的擁有者將很快審核並批准此批次。",
        BatchRejected: "批次被拒絕",
        BatchRejectedDesc: "您的擁有者拒絕了此批次。",
        Reason: "原因",
        Approve: "批准",
        Reject: "拒絕",
        ConfirmApproveTitle: "批准批次",
        ConfirmRejectTitle: "拒絕批次",
        ConfirmApprovalAction: "您確定要{action}此批次嗎？此操作將更新其狀態。",
        ReasonOptional: "原因（可選）",
        EnterReasonPlaceholder: "輸入{action}的原因（可選）",
        Processing: "處理中...",
        BatchActivatedSuccess: "批次已成功啟用",
        BatchDeactivatedSuccess: "批次已成功停用",
        BatchDeletedSuccess: "批次已成功刪除",
        BatchApprovedSuccess: "批次已成功批准",
        BatchRejectedSuccess: "批次已成功拒絕",
        SearchByBatchName: "按批次名稱搜尋...",
        YesTurnOff: "是，關閉",
        KeepItOn: "保持開啟"
    },
    CategoryNewL: {
        TotalCategories: "總類別數",
        lastaddedcategory: "上次新增的類別",
        acrossalltypes: "跨所有類型",
        MostRecent: "最近",
        YesD: "是的，刪除",
        AllAssociated: "所有相關產品都可能受到影響"
    },
    OverDas: {
        movestockbetweenlocations: "移動庫存",
        no_activity_yet: "尚無任何活動",
        no_activity_sub: "銷售、採購、庫存移動和退貨將在此即時顯示。",
        make_first_sale: "進行第一次銷售",
        add_stock: "新增庫存",
        all_stock_healthy: "所有庫存水平正常",
        all_stock_healthy_sub: "沒有任何商品即將缺貨。請在商品上設定最低門檻，以便在此接收提醒。",
        set_stock_thresholds: "設定庫存門檻",
        no_warehouses_setup: "尚未設定任何倉庫",
        no_warehouses_setup_sub: "新增一個倉庫以開始追蹤您的庫存存放位置並管理地點。",
        add_first_warehouse: "新增第一個倉庫",
        Customer: "客戶",
        PurchasevsSales: "採購 vs 銷售",
        Financialperformancechart: "財務表現圖表",
        QuickActions: "快速操作",
        Frequentlyused: "常用功能",
        Addinventory: "新增庫存",
        Dispatchitems: "調撥商品",
        Addorder: "新增訂單",
        Newitem: "新商品",
        Inventoryaccess: "庫存存取",
        Itemsneedingreorder: "需要補貨的商品",
        Latesttransactions: "最新交易",
        Operationalsummary: "營運摘要",
        ViewAll: "查看全部",
        Manage: "管理",
        RecentActivity: "最近活動",
        LowStockAlerts: "低庫存提醒",
        Primary: "主要",
        TotalWarehouses: "倉庫總數"
    },
    SerialLocal: {
        ShowOrHideFields: "顯示或隱藏欄位",
        ShowOrHideFieldsDesc: "點擊下方的任何項目以將其包含在列印的發票中或從中移除。變更會立即生效。",
        Manufacturesettings: "製造設定",
        Showbuyingprice: "購買價 / 產品成本",
        Showadditionalcost: "額外費用",
        Costbreakdown: "費用明細",
        Unitcost: "單位成本",
        Rawmaterialstotal: "原材料總計",
        Confirmentry: "確認輸入",
        SaveSerials: "儲存序號",
        SerialNumber: "序號",
        selected: "已選擇",
        added: "已新增",
        Serialnumbers: "序號",
        ResetAll: "全部重設",
        Wecouldnfindthis: "找不到此產品的可用序號。",
        Nounitsfound: "找不到任何單位",
        Searchingserialnumbers: "正在搜尋序號...",
        Scanorenterstock: "掃描或輸入新庫存的序號",
        Whataserialnumber: "什麼是序號？",
        Auniqueidentifieryourinventorylifecycle: "每個單位獨一無二的識別碼 — 可讓您在整個庫存生命週期中追蹤每個個別項目。",
        Trackedstockout: "已追蹤出庫",
        Chooseexactlyselected: "請準確選擇要離開的序號。只會顯示此產品已入庫的序號 — 選擇後數量將被鎖定 ",
        SelectSerialstoout: " - 選擇要出庫的序號",
        Thisinvoicegeneratedusingwwwsimplstockco: "此發票使用 www.simplstock.co 生成",
        AuthorizedSignature: "授權簽名",
        Invoicesettings: "發票設定",
        Draw: "繪製",
        Taptoselectordeselectitems: "點擊以選擇或取消選擇項目",
        Thissignaturewillbeadded: "此簽名將新增至您列印發票的底部。",
        SignatureOptions: "簽名選項",
        Upload: "上傳",
        DrawSignature: "手繪簽名",
        UploadSignature: "上傳簽名",
        Clear: "清除",
        ShowStaffName: "員工姓名",
        ShowSKU: "SKU",
        ShowBusinessName: "公司名稱",
        ShowProductName: "產品名稱",
        ShowBusinessPhoneNumber: "業務電話號碼",
        ShowBusinessEmail: "業務電子郵件",
        ShowBusinessAddress: "業務地址",
        ShowProductImage: "產品圖片",
        ShowPaymentDetails: "付款詳情",
        ShowCategory: "分類",
        ShowVariant: "規格",
        ShowWarehouse: "倉庫",
        ShowAttributes: "屬性",
        ShowQuantity: "數量",
        ShowDiscount: "折扣",
        ShowTax: "稅金",
        ShowPrice: "價格",
        ShowTotalPrice: "產品總價",
        ShowExpenses: "費用",
        ShowSignature: "簽名",
        ShowNote: "備註",
        ShowSerialNumber: "序號",
        Invoicesettingsapplied: "發票設定已套用。請檢查發票以查看變更。",
        EnterSerialNumber: "輸入序號",
        showAttachment: "附件"
    },
    FewLocal: {
        SelectBin: "選擇貨位",
        Live: "即時",
        Monitorinventorystocklevels: "監控庫存、移動及庫存水平",
        StockControlCentre: "庫存控制中心",
        Nochartdataavailable: "沒有圖表數據",
        Disabled: "已停用",
        Enabled: "已啟用"
    },
    Bin: {
        Bin: "貨位",
        Add: "新增",
        NoBinsAddedYet: "尚未新增任何貨位",
        BinLocationsHelp: "貨位有助您按照倉庫內的精確位置追蹤庫存 — 無需再搜尋。",
        NameThemByPosition: "按位置命名：",
        AddBinLocation: "新增貨位",
        BinLocations: "貨位",
        BinNameRequired: "貨位名稱必填",
        EditBin: "編輯貨位",
        AddBin: "新增貨位",
        EnterBinName: "貨位名稱",
        EnterBinNamePlaceholder: "輸入貨位名稱",
        BinStatus: "貨位狀態",
        BinNotes: "備註",
        EnterBinNotesPlaceholder: "新增一些備註...",
        ViewInventory: "查看庫存",
        Inventory: "庫存",
        TrymatchingadifferentSKUname: "嘗試匹配其他SKU或名稱。",
        Thisbinlocationcurrentlyempty: "此貨位目前為空。",
        Loadingbins: "正在載入貨位...",
        bins: "貨位",
        ManageBin: "管理貨位",
        Print: "列印",
        SBin: "源儲位",
        DBin: "目的地儲位"
    },
    WarehouseExcel: {
        title: "上傳倉庫 & 貨位",
        description: "按照以下步驟使用 Excel 檔案批量建立倉庫及其貨位。",
        bulkUploadGuide: "批量上傳指南",
        step1: "步驟 1",
        downloadTemplate: "下載 Excel 範本",
        downloadTemplateDesc: "下載已預置所有必要欄位標題的官方範本。請勿重新命名或刪除任何欄位。",
        downloadTemplateBtn: "下載範本",
        step2: "步驟 2",
        fillExcelFile: "填寫 Excel 檔案",
        fillExcelDesc: "每一列代表一個倉庫。請填寫所有欄位 — 貨位請在 <code>Bin Names</code> 欄位中用逗號分隔輸入所有貨位名稱。",
        step3: "步驟 3",
        thingsToKeepInMind: "注意事項",
        rulesDesc: "上傳前，請確保您的檔案符合以下規則。",
        step4: "步驟 4",
        uploadYourFile: "上傳您的檔案",
        uploadDesc: "填寫完成後，上傳下方檔案。系統將自動建立所有倉庫和貨位。",
        rules: ["每個倉庫僅一列", "貨位名稱用逗號分隔在一個儲存格內", "請勿修改欄位標題名稱", "同一倉庫內重複的貨位名稱將被跳過", "帶國家代碼的電話號碼", "僅支援 .xlsx 或 .xls 檔案"],
        dropFileHere: "將 Excel 檔案拖放到此處",
        supports: "支援 .xlsx 和 .xls — 最大 10 MB",
        chooseFileUpload: "選擇檔案並上傳",
        parsing: "正在解析檔案...",
        invalidFileType: "無效的檔案類型。請上傳 Excel 檔案。",
        noData: "Excel 中未找到資料",
        failedToRead: "無法讀取 Excel 檔案",
        unableToRead: "無法讀取檔案。",
        reviewTitle: "審核倉庫資料",
        reviewSubtitle: "匯入您的業務前的最終檢查。",
        changeFile: "更改檔案",
        rowsFound: "列已找到",
        cancel: "取消",
        finalizeImport: "完成並匯入",
        importing: "正在匯入...",
        success: "成功",
        allWarehouseUploadedSuccess: "所有倉庫已成功上傳",
        failed: "失敗",
        bulkUploadFailed: "批量上傳失敗",
        error: "錯誤",
        binNamesNote: "在 <strong>Bin Names</strong> 欄位中，將一個倉庫的所有貨位名稱用逗號分隔輸入到一個儲存格中 — 例如：A1, A2, B1, RACK-01。",
        headers: { warehouseName: "倉庫名稱", email: "電郵", phoneNumber: "電話號碼", location: "位置", binNames: "貨位名稱" }
    },
    VariantTemplate: {
        VariantTemplates: "變體模板",
        Managereusablevariantpatterns: "管理可重複使用的變體模式",
        BinTransferHistory: "貨位轉移記錄",
        Trackmovementsacrossbins: "追蹤貨位之間的移動",
        SerialNumberHistory: "序號記錄",
        Trackproductserialnumberactivity: "追蹤產品序號活動",
        Period: "期間",
        Nohistoryfound: "未找到記錄",
        Searchserialnumbers: "搜尋序號...",
        SerialNumbersHistory: "序號歷史",
        Serialnumberhistoryglance: "序號歷史一覽。",
        Noserialnumbersfound: "未找到序號",
        Noactivityhistoryfound: "未找到活動記錄",
        Statussetto: "狀態設定為",
        Timeline: "時間軸",
        Managereusableproductvariantpatterns: "管理可重複使用的產品變體模式。",
        DeleteTemplate: "刪除模板",
        Areyousureyouwanttemplate: "確定要刪除此模板嗎？",
        CreateNewTemplate: "建立新模板",
        CreateTemplate: "建立模板",
        EditTemplate: "編輯模板",
        UnlimitedTemplates: "無限模板",
        CreateAsManyTemplates: "根據需求建立任意數量的模板 — 服裝、鞋類、電子產品等。",
        PickWhileAddingProduct: "新增產品時選擇",
        OpenTemplateLibrary: "開啟模板庫，幾秒內即可選擇變體名稱。",
        MixFromMultipleTemplates: "從多個模板混合",
        SelectFromMultipleTemplates: "為單一產品從多個模板選擇變體名稱 — 完全彈性。",
        EditAnytime: "隨時編輯",
        RenameTemplatesAnytime: "隨時重新命名模板、新增或移除變體名稱。",
        StayConsistent: "保持一致性",
        SameVariantNamesAcrossAll: "所有產品使用相同的變體名稱。無錯字、無重複、無猜測。",
        BuildOnceUseEverywhere: "一次建立， 處處使用",
        StopReEnteringVariantNames: "停止為每個產品重複輸入相同的變體名稱。建立一次模板即可立即重用。",
        Updateexistingvariantcombinations: "更新現有變體組合",
        Definenewvariantcombinations: "定義新的變體組合",
        TemplateName: "模板名稱",
        AddVariantOptions: "新增變體選項",
        SmallMedium: "例如：小、中...",
        VariantsList: "變體列表",
        Nooptionsaddedyet: "尚未新增任何選項",
        SaveTemplate: "儲存模板",
        egSizesColorsetc: "例如：T恤尺寸、顏色等",
        Pleaseentertemplatename: "請輸入模板名稱",
        Pleaseaddatleastonevariantoption: "請至少新增一個變体選項",
        Templateupdatedsuccessfully: "模板更新成功",
        Templatecreatedsuccessfully: "模板建立成功",
        Failedtosavetemplate: "儲存模板失敗",
        Transfer: "轉移",
        Editassignment: "編輯指派",
        Updateproductdetailsinbin: "更新貨位中的產品資訊",
        Editinginbin: "正在貨位中編輯",
        ConfirmUpdate: "確認更新",
        ConfirmAssign: "確認指派",
        Assignanotherproduct: "指派其他產品",
        TransferBin: "轉移貨位",
        SourceBin: "來源貨位",
        DestinationBin: "目標貨位",
        SelectSourceBin: "選擇來源貨位",
        SelectDestinationBin: "選擇目標貨位",
        Unit: "單位",
        ManageVariant: "管理變體",
        CreateSKUvariationsyourproduct: "為您的產品建立SKU變體",
        Assigningvariationsto: "正在指派變體至",
        Novariantsaddedyet: "尚未新增任何變體",
        AddedVariants: "已新增變體",
        AddVariantsfromTemplate: "從模板新增變體",
        Pickatemplateandselectvariantnames: "選擇模板並選取變體名稱",
        ChooseaTemplate: "選擇模板",
        Selectvariantnamestoadd: "選擇要新增的變體名稱",
        SelectatemplatetopickvariantnamesfroYoucanaddfrommultiple: "選擇一個模板來挑選變體名稱。您可以從多個模板新增。",
        Loadingtemplates: "正在載入模板...",
        Backtotemplates: "返回模板列表",
        Selectallindividualadd: "全選或個別選擇變體名稱新增。",
        VariantNames: "變體名稱",
        MediaDescription: "媒體 & 描述",
        Addattachmentsandproductnotes: "新增附件和產品備註",
        ProductMedia: "產品媒體"
    },
    AddProductGuide: {
        title: "儲存後新增初始數量",
        description: "產品在此沒有數量欄位。儲存後，請使用「入庫」記錄您的期初庫存 — 對位置和追蹤擁有完全控制權。",
        steps: {
            quantity: { title: "數量", sub: "設定期初庫存數量" },
            binLocation: { title: "貨位", sub: "通道、貨架、層架 — 例如：A-01-03" },
            serialNumbers: { title: "序號", sub: "個別追蹤每個單位" },
            warehouse: { title: "倉庫", sub: "儲存在哪個位置" },
            batchExpiry: { title: "批次 / 到期日", sub: "按批次號分組庫存" }
        },
        actions: { close: "關閉" }
    },
    Remainingtranferitems: {
        NoTransferOrdersFound: "未找到調撥單",
        Itemshistory: "您在倉庫之間轉移的物品將在此顯示，用於追蹤และ歷史記錄。",
        CreateTransfer: "建立調撥"
    },
    ManufactureLocal: {
        TaponproducttoManufacture: "點擊產品進行製造",
        Selectproductfrombelow: "從下方清單中選擇產品",
        SetupANewProduct: "設置新產品",
        DefineAProductAdditsrawmaterial: "定義產品並添加其原材料",
        ManufacturingSetup: "製造設置",
        Pickproducttodefineitsproductiondetails: "選擇產品以定義其生產詳情",
        ConfigureManufacturing: "配置製造",
        SelectRawMaterial: "選擇原材料",
        NoRawMaterials: "無原材料",
        Definecomponentsneededtoproduct: "定義製造此產品所需的組件。",
        NoAdditionalCosts: "無額外成本",
        Addlaboroverheadlogisticalcharges: "添加人工、間接費用或物流費用。",
        AddAdditionalCost: "添加額外成本",
        AddCost: "添加成本",
        TotalPrice: "總價",
        SelectCharges: "選擇費用",
        EnterEstimatedCost: "輸入估計成本",
        QtyRequried: "所需數量",
        Manufacturing: "製造",
        Outputfinishedgoodsdestination: "成品目的地",
        Manufacturingquantity: "製造數量",
        Storefinishedgoodsat: "將成品存放在",
        Rawmaterials: "原材料",
        StockSelection: "庫存選擇",
        AdditionalCosts: "額外成本",
        Quantityconsume: "消耗數量",
        Totalmanufacturingcost: "總制造成本",
        Sumofrawmaterialcosts: "所有原材料成本的總和",
        CustomManufacturingCharge: "自定義製造費用",
        Addextralikelaboroverheadrepairs: "添加額外費用，如人工、間接費用或維修。",
        CalculatedTotal: "計算總額",
        AddRawMaterial: "添加原材料",
        ConfigureRawMaterial: "配置原材料",
        Thisoutputunit: "這是每單位產出所需的基礎數量。",
        ChangeProduct: "更換產品",
        AddtoList: "添加到列表",
        ManufacturedSuccessfully: "製造成功",
        Manufacture: "製造",
        EditDeleteHistory: "編輯/刪除記錄",
        ManageOrder: "管理訂單",
        ManageBatch: "管理批次",
        Paymentnotavailablehere: "此處無法付款",
        Thisrecordisanorderorderitself: "此記錄來自訂單。只能從訂單本身記錄付款。",
        Torecorpaymenttheorderthethere: "要記錄付款，請前往關聯訂單並在那裡使用<b>記錄付款</b>選項。",
        GotoOrder: "轉到訂單"
    },
    CustomerExcel: {
        title: "上傳客戶",
        description: "按照以下步驟使用 Excel 檔案批量建立客戶。",
        bulkUploadGuide: "批量上傳指南",
        step1: "第 1 步",
        downloadTemplate: "下載 Excel 範本",
        downloadTemplateDesc: "獲取預先配置了所有必需欄位標題的官方範本。",
        downloadTemplateBtn: "下載範本",
        step2: "第 2 步",
        fillExcelFile: "填寫 Excel 檔案",
        fillExcelDesc: "每一列代表一個客戶。按要求填寫所有欄位。",
        step3: "第 3 步",
        thingsToKeepInMind: "注意事項",
        rulesDesc: "上傳前，請確保您的檔案遵循這些規則以避免錯誤。",
        step4: "第 4 步",
        uploadYourFile: "上傳您的檔案",
        uploadDesc: "填寫完成後，在下方上傳檔案。系統將自動建立所有客戶。",
        rules: [
            "每列僅限一個客戶",
            "請勿重新命名欄位標題",
            "帶國家代碼的聯絡電話",
            "僅接受 .xlsx 或 .xls 檔案"
        ],
        dropFileHere: "將 Excel 檔案拖放到此處",
        supports: "支援 .xlsx 和 .xls — 最大 10 MB",
        chooseFileUpload: "選擇檔案並上傳",
        parsing: "正在解析檔案...",
        invalidFileType: "檔案類型無效。請上傳 Excel 檔案。",
        noData: "在 Excel 中未找到資料",
        failedToRead: "讀取 Excel 檔案失敗",
        unableToRead: "無法讀取檔案。",
        reviewTitle: "審核客戶資料",
        reviewSubtitle: "匯入您的業務前的最後檢查。",
        changeFile: "更改檔案",
        rowsFound: "在檔案中找到列",
        cancel: "取消",
        finalizeImport: "完成並匯入",
        importing: "正在匯入...",
        success: "成功",
        allCustomerUploadedSuccess: "所有客戶已成功上傳",
        failed: "失敗",
        bulkUploadFailed: "批量上傳失敗",
        error: "錯誤",
        headers: {
            customerName: "客戶名稱",
            phoneNumber: "聯絡方式",
            address: "地址",
            note: "備註"
        }
    },
    SupplierExcel: {
        title: "上傳供應商",
        description: "按照以下步驟使用 Excel 檔案批量建立供應商。",
        bulkUploadGuide: "批量上傳指南",
        step1: "第 1 步",
        downloadTemplate: "下載 Excel 範本",
        downloadTemplateDesc: "獲取預先配置了所有必需欄位標題的官方範本。",
        downloadTemplateBtn: "下載範本",
        step2: "第 2 步",
        fillExcelFile: "填寫 Excel 檔案",
        fillExcelDesc: "每一列代表一個供應商。按要求填寫所有欄位。",
        step3: "第 3 步",
        thingsToKeepInMind: "注意事項",
        rulesDesc: "上傳前，請確保您的檔案遵循這些規則以避免錯誤。",
        step4: "第 4 步",
        uploadYourFile: "上傳您的檔案",
        uploadDesc: "填寫完成後，在下方上傳檔案。系統將自動建立所有供應商。",
        rules: [
            "每列僅限一個供應商",
            "請勿重新命名欄位標題",
            "帶國家代碼的聯絡電話",
            "僅接受 .xlsx 或 .xls 檔案"
        ],
        dropFileHere: "將 Excel 檔案拖放到此處",
        supports: "支援 .xlsx 和 .xls — 最大 10 MB",
        chooseFileUpload: "選擇檔案並上传",
        parsing: "正在解析檔案...",
        invalidFileType: "檔案類型無效。請上傳 Excel 檔案。",
        noData: "在 Excel 中未找到資料",
        failedToRead: "讀取 Excel 檔案失敗",
        unableToRead: "無法讀取檔案。",
        reviewTitle: "審核供應商資料",
        reviewSubtitle: "匯入您的業務前的最後檢查。",
        changeFile: "更改檔案",
        rowsFound: "在檔案中找到列",
        cancel: "取消",
        finalizeImport: "完成並匯入",
        importing: "正在匯入...",
        success: "成功",
        allSupplierUploadedSuccess: "所有供應商已成功上傳",
        failed: "失敗",
        bulkUploadFailed: "批量上傳失敗",
        error: "錯誤",
        headers: {
            supplierName: "供應商名稱",
            phoneNumber: "聯絡方式",
            bankName: "銀行名稱",
            accountHolderName: "帳戶持有人姓名",
            accountNumber: "帳號",
            note: "備註"
        }
    },
    ReplaceReturnLocal: {
        ReplacedWith: "更換為",
        Noreplacementhistoryfound: "未找到更換記錄",
        Noreturnhistoryfound: "未找到退貨記錄",
        Productbeingreturned: "退回的產品",
        Required: "必填",
        Selectreturnedproduct: "選擇退回的產品",
        Searchnamescanbarcode: "按名稱、SKU 搜尋或掃描條碼",
        Browse: "瀏覽",
        Stockhandling: "入庫處理",
        Stockinreturnedproduct: "將退回產品入庫",
        Ontoinventory: "開啟 — 退回物品將重新添加至庫存",
        Offreturnedonly: "關閉 — 物品僅記錄為退回",
        Usedrestock: "用於計算補貨時的利潤調整",
        Willaddedbackconfirmation: "確認後將重新添加至庫存",
        Returnreason: "退貨原因",
        Optional: "選填",
        SelectReason: "選擇原因",
        Additionalnotes: "補充備註",
        Describeofcustomerexplanation: "描述退回物品的狀態、任何明顯的損壞、客戶的解釋等...",
        Requiredmustfilledcontinue: "必須填寫必填欄位才能繼續",
        Reviewdetailsbeforeconfirming: "確認前請檢查詳情",
        Replacementproductwilldeductedinventoryconfirmation: "確認後，更換產品將從您的庫存中扣除。",
        Choosereplacementproduct: "選擇更換產品",
        Willdeductedfrominventoryconfirm: "確認後將從庫存中扣除",
        Thesewillattachedothereturnrecord: "這些圖片將附在退貨記錄中",
        Replacementitem: "更換物品",
        Addanotherproduct: "新增另一個產品",
        Replacementproductwillbe: "更換產品將在確認後",
        deducted: "扣除",
        fromyourinventoryconfirmation: "自您的庫存中。",
        productadjustedusingprice: "退回的產品將重新入庫，並使用原銷售價格調整利潤。",
        Willloggedreturnedonlynotrestocked: "僅記錄為退回 — 不重新入庫",
        Returnonly: "僅退貨",
        Imagesofreturnedproduct: "退回產品的圖片",
        Returnedproductwill: "退回的產品",
        not: "不會",
        berestockedloggedreturnedonly: "重新入庫 — 僅記錄為退回。",
        AddImage: "新增圖片",
        STOCKIN: "入庫",
        LOGONLY: "僅記錄",
        ContinuetoReview: "繼續檢查 →",
        Confirmreplacement: "確認更換",
        Confirmreturn: "確認退貨",
        Filldetailsbelowproceed: "請填寫以下詳情以繼續",
        Review: "檢查",
        editdetails: "編輯詳情",
        Configurereturndetails: "配置退貨詳情",
        Configurereplacementdetails: "配置更換詳情",
        SelectSource: "選擇來源",
        Returning: "退貨中",
        Replacement: "更換",
        WalkCustomer: "散客",
        RETURNEDPRODUCT: "退回產品",
        REPLACEMENTPRODUCT: "更換產品",
        STOCKOUT: "出庫",
        Netinventoryimpact: "淨庫存影響",
        Replacementitemcost: "更換物品成本",
        Returneditemrestockvalue: "退回物品入庫價值",
        PROFITINVENTORYSUMMARY: "利潤與庫存摘要",
        Inventoryaction: "庫存操作",
        Valuededucted: "扣除價值",
        Profitadjustment: "利潤調整",
        stockedout: " 已出庫",
        restocked: " 已入庫",
        Noaction: "無操作",
        Valuebeingreturned: "退回價值",
        Willberestocked: "將入庫",
        Willbe: "將",
        logged: "記錄",
        ON: "開啟",
        OFF: "關閉",
        Linked: "已連結",
        Pleaseselectreturnedproduct: "請選擇退貨產品",
        Quantityrequired: "數量為必填",
        Buyingpricerequired: "購買價為必填",
        Pleaseaddleastreplacementproduct: "請至少新增一個替換產品",
        Pleaseconfigurereturnedproductdetails: "請設定退貨產品詳細資料",
        Pleaseselectcustomer: "請選擇客戶",
        Returndateisrequired: "退貨日期為必填",
        Pleasefillallrequiredfields: "請填寫所有必填欄位",
        Wildeductedfrominventory: "將從庫存中扣除",
        Currentprice: "目前價格",
        Defectivedamaged: "有瑕疵 / 損壞",
        Wrongitemreceived: "收到錯誤商品",
        Customerchangedmind: "顧客改變心意",
        Sizefitissue: "尺寸 / 合身問題",
        Notasdescribed: "與描述不符",
        Other: "其他",
        Originalsaleprice: "原始售價（利潤調整）",
        Addedbackinventory: "已加回庫存",
        Notaddedinventory: "未加入庫存",
        replacedwith: "替換為",
        deductedfrominventory: "從庫存扣除",
        RETURNWITHSTOCKIN: "退貨 · 有入庫",
        RETURNNOSTOCKIN: "退貨 · 無入庫",
        MULTIPLEREPLACEMENTS: "多次更換",
        SINGLEREPLACEMENT: "單次更換",
        InternalTrackingRecordInfo: "This is a record for internal tracking. This process DOES NOT automatically update or delete related invoices, orders, or accounts.",
        ManualStepsIfNeeded: "Manual Steps (if needed):",
        ManualStep1: "Return/Delete invoice from Sale History",
        ManualStep2: "Adjust customer ledger manually",
        ManualStep3: "Update related purchase record",
        RETURNEDSTOCKIN: "已退貨 · 庫存入",
        REPLACEMENTSTOCKOUT: "更換 · 庫存出",
        Returnonlylogsthisentry: "退貨僅記錄此條目 —",
        nostockwillbeaddedorremoved: "不會增加或移除庫存",
        frominventory: "從庫存中。",
        Whentousethis: "何時使用此功能：",
        UseReturnenddayrecorditemsoutsalesthatcamebackunusablewantinventory: "在一天結束時使用「僅退貨」來記錄因銷售而發出的物品，但在退回時已損壞或無法使用 — 您想要跟踪但無法重新加入庫存的物品。",
        Youcanviewallpastreturnentriesin: "您可以在以下位置查看所有過去的退貨記錄：",
        ReturnHistory: "退貨歷史",
        underthe: "在",
        Others: "其他",
        tab: "選項卡下。"
    },
    NewRLocal: {
        Originalsaleprice: "原始銷售價格",
        Editinghistoryonlyinventorystaysunchanged: "僅編輯歷史記錄 — 庫存保持不變。",
        Changeshereupdatethisdetailsquantitiesaffected: "此處的更改僅更新此記錄的詳細資訊（原因、日期、備註）。您的實際庫存數量、貨位和產品數據不會受到影響。",
        Needtofixinventorylevelsinstead: "需要改為修正庫存水平嗎？",
        AdjustStock: "調整庫存",
        Refund: "退款",
        ImportantNote: "重要提示",
        Pleasereviewbeforecontinuing: "請在繼續之前查看",
        Onceshippedreceivedanyupdatesmadeorder: "訂單一旦出貨或接收，對訂單所做的任何更新都不會反映在交易歷史記錄中。",
        Thisundone: "這將永久移除訂單。此操作無法撤銷。",
        Inventorywilladjustedautomatically: "庫存不會自動調整",
        Deletingthisreversevedshippedyouwillneed: "刪除此操作不會撤銷任何庫存更改。如果物品已接收/出貨，您將需要",
        reflectthecorrectstocklevels: "以反映正確的庫存水平。",
        manuallyadjustyourinventory: "手動調整您的庫存",
        Addremovestockforitemsthatwereshipped: "為已出貨物品添加/移除庫存",
        Addremovestockforitemsthatwerereceived: "為已接收物品添加/移除庫存",
        Updatecostrecordspaymentwaalreadymade: "如果已付款，請更新成本記錄",
        Reconcilerecordsandoutstandingpayments: "核對記錄和未付賬款"
    },
    ReceivablesLocal: {
        Receivables: "應收帳款",
        Manageandtrackcustomerduebalances: "管理並追蹤客戶到期餘額",
        Viewcustomerduebalancereport: "查看客戶到期餘額報表",
        Viewsupplierduebalancereport: "查看供應商到期餘額報表",
        DueBalance: "到期餘額",
        Unpaid: "未付款",
        PartiallyPaid: "部分付款",
        Paid: "已付款",
        HighestBalance: "最高餘額",
        LowestBalance: "最低餘額",
        Filldetailsrecordpayment: "填寫詳細資料以記錄付款",
        NewPaymentEntry: "新增付款記錄",
        EditPaymentEntry: "編輯付款記錄",
        Nosuppliersfound: "未找到供應商",
        Nocustomersfound: "未找到客戶",
        LowtoHigh: "低到高",
        HightoLow: "高到低",
        AttachmentUploadedSc: "附件上傳成功",
        AttachmentUploadedF: "附件上傳失敗",
        Pay: "付款",
        NoBillsFound: "未找到帳單",
        Thiscustomerhasunpaidbills: "此客戶沒有未付帳單。",
        TotalDue: "總計到期",
        BillsFound: "找到帳單",
        DeselectAll: "取消全選",
        SelectAll: "全選",
        ShowDetails: "顯示細節"
    },
    AssetsNewLocal: {
        Assignedon: "分配於",
        Total: "總計",
        Assigned: "已分配",
        Remaining: "剩餘",
        Available: "可用",
        NoSerialNumbers: "無序列號",
        UpdateExistingAssetDetails: "更新現有資產詳情",
        RegisterNewBusinessAsset: "註冊新的業務資產",
        BasicInformation: "基本信息",
        AssetDetails: "資產詳情",
        Quantity: "數量",
        SerialNumbers: "序列號",
        SerialNumberPlaceholder: "序列號",
        AddSerialNumber: "添加序列號",
        SerialNumbersOptional: "序列號為選填項。您最多可以添加",
        AssetImages: "資產圖片",
        AdditionalNotes: "備註",
        AdditionalNotesPlaceholder: "任何其他詳情或維護歷史...",
        Updating: "更新中...",
        Adding: "添加中...",
        ITEquipmentPlaceholder: "例如：IT設備",
        LoadingMoreActivities: "正在加載更多活動...",
        AssignedAssets: "已分配資產",
        Noassetsassignedstaffmember: "此員工沒有分配任何資產。",
        Assignassetstaff: "分配資產給員工",
        Returnassetfromstaff: "從員工處歸還此資產",
        AssignmentDetails: "分配詳情",
        Serial: "序列號",
        ViewAssets: "查看所有資產",
        ViewByStaff: "按員工查看",
        AssignedHistory: "分配歷史",
        Returned: "已歸還",
        Returnedon: "歸還日期",
        ReturnedBy: "歸還人",
        AssignedTo: "分配給",
        NoHistoryRecords: "沒有歷史記錄",
        Selectstaffmemberviewtheirassets: "選擇員工以查看其資產",
        Deleted: "已刪除",
        searchPlaceholder: "按名稱或序號搜尋資產..."
    },
    InventoryCountLocale: {
        InventoryCount: "庫存盤點",
        Viewinventorycountreport: "查看庫存盤點報表",
        ItemsCount: "商品數量",
        All: "全部",
        InProgress: "進行中",
        Submitted: "已提交",
        awaitingreview: "等待審核",
        EditInventoryCount: "編輯盤點",
        NewInventoryCount: "新增盤點",
        Modifyinventorycountsheetdetails: "修改盤點表詳細資料",
        Startanewinventorycountsheet: "開始新的盤點表",
        GeneralInformation: "基本資訊",
        Title: "標題",
        SaveChanges: "儲存變更",
        Selectproductsforthisinventorycountsheet: "選擇本次盤點的商品",
        InventoryCountDetails: "盤點詳細資料",
        Inventorycountsheetdetails: "盤點表詳細資料",
        Viewingdetailsforcountsheet: "正在查看盤點表詳細資料",
        Started: "已開始",
        TaskSheets: "任務表",
        Allitems: "所有商品",
        NotStarted: "未開始",
        Completed: "已完成",
        Results: "結果",
        ViewResults: "查看結果",
        DeleteInventoryCount: "刪除盤點",
        Viewingtransactionandadjustments: "查看交易記錄和庫存調整",
        Productsadjusted: "已調整商品",
        Assignee: "負責人",
        Tasksheetdetails: "任務表詳細資料",
        Draft: "草稿",
        VariantQuantities: "變體數量",
        AssignedProducts: "已分配商品",
        ReturnAsset: "歸還資產",
        EditTasksheet: "編輯任務表",
        NewTasksheet: "新增任務表",
        Updatetasksheetdetails: "更新任務表詳細資料",
        Starttasksheetforthisinventorycount: "為此盤點開始新的任務表",
        TaskSheetInformation: "任務表資訊",
        SheetTitle: "表格標題",
        Entersheettitle: "輸入表格標題",
        SubmissionResult: "提交結果",
        ReviewChanges: "審核變更",
        Viewingsubmissionresultsforthisinventorycount: "查看此盤點的提交結果",
        Reviewyourinventorycountbeforesubmitting: "提交前請檢查您的庫存盤點"
    },
    NewMissingLocale: {
        Failedtoloadcounts: "載入盤點失敗",
        NoInventoryCounts: "沒有庫存盤點",
        NoMatches: "沒有符合項目",
        Therearenoinventorycountswiththestatus: "沒有此狀態的庫存盤點",
        Noinventorycountsfoundyoursearchterm: "未找到符合您搜尋詞彙的庫存盤點",
        Thereareinventorycountsrecordedyetforthisbusiness: "此業務尚未記錄任何庫存盤點"
    },
    StockinModalP: {
        StockInNow: "立即入庫",
        Settheopeningquantityforthisproductrightnow: "立即設定此產品的初始數量。",
        Addinitialstock: "新增初始庫存？",
        dothislater: "稍後再做",
        Productadded: "商品新增成功！",
        isready: "已就緒。",
        SeeHowItWorks: "查看運作方式",
        NoSalesOrdersFound: "未找到銷售訂單",
        NoPurchaseOrdersFound: "未找到採購訂單",
        Startcreatingoutgoinginventoryrevenue: "開始建立銷售訂單以追蹤出庫庫存和收入。",
        Trackrestockssupplierplace: "在一個地方追蹤庫存補貨和供應商訂單。",
        CreateSalesOrder: "建立銷售訂單",
        CreatePurchaseOrder: "建立採購訂單"
    }
    ,
    dialy_report: "每日變動報告",
    Quotation: "報價",
    Quote: "報價",
    Assignee: "負責人",
    dayStart: "一日開始",

    ShowTotalAmount: "總金額",


    tutorial: {
        watchTitle: '觀看逐步教學課程',
        watchDesc: '在我們的YouTube頻道上學習SimplyStock',
        modalTitle: '使用SimplyStock保持領先地位',
        modalDesc: '訂閱即可在新教程下載時獲得新教程',
        feature1Title: '全新功能逐步解說',
        feature1Sub: '每次更新都會透過簡短影片進行說明，讓您永遠不會錯過新功能',
        feature2Title: '快速操作影片',
        feature2Sub: '在5分鐘內設定庫存、發票、員工存取權限等',
        feature3Title: '即時通知',
        feature3Sub: '在新教程上線時獲得通知—按照自己的步調學習',
        feature4Title: '完全免費，永久免費',
        feature4Sub: '所有教程都是永久免費的—無需登入或訂閱',
        subscribeBtn: '訂閱SimplyStock',
        maybeLater: '稍後'
    }
    ,
    dailyCashReport: {
        "title": "每日現金報表",
        "subtitle": "誰在什麼日期支付了什麼，還有什麼未付 — 根據銷售明細彙總。",
        "totalSales": "總銷售額",
        "cashReceived": "總共收到",
        "outstanding": "未結清",
        "collectionRate": "收款率",
        "grandTotalAllDates": "總計（所有日期）",
        "totalLabel": "總計",
        "loading": "載入中...",
        "noData": "找不到選定日期範圍的資料。",
        "loadingMore": "載入更多..."
    },
    dailyCashReportColumns: {
        "date": "日期",
        "customer": "客戶",
        "productsSold": "售出產品",
        "products": "產品",
        "salesAmount": "銷售金額",
        "sales": "銷售",
        "received": "總共收到",
        "receivedShort": "已收",
        "debited": "借記到分類帳",
        "due": "應付",
        "paymentModes": "支付方式",
        "mode": "方式"
    }
}

export default zh_TW
